const expandKeyedTranslations = (group) => {
  const translations = {}

  Object.entries(group).forEach(([phrase, byLanguage]) => {
    Object.entries(byLanguage).forEach(([language, translation]) => {
      translations[language] = translations[language] || {}
      translations[language][phrase] = translation
    })
  })

  return translations
}

const sampleImageNote =
  '* Note: The sample image is only used to display measurement locations and body parts. The table on the right displays your measurements.'
const sampleImageClientNote =
  "* Note: The sample image is only used to display measurement locations and body parts. The table on the right displays the client's measurements."
const userBfp =
  "Body fat percentage is the user's total fat mass divided by the total body mass. Fat is an essential component of the body, however, too much body fat can negatively affect overall health."
const personWeight = "Body weight is a person's mass or weight."
const waistDesc =
  'A larger waist circumference can mean more "deep" (visceral) fat which is an unhealthy type of fat that wraps around internal organs and can lead to additional health risks. Generally a lower waist circumference is better. Waist circumference has been widely used in the past due to its simplicity.'
const whrDesc =
  'Waist to hip ratio describes body shape using a ratio between waist and hips. A lower ratio generally means lower risk for certain health issues. If you have heard of body shapes described as apple or pear, these are two ends of the WHR spectrum where pear has a lower WHR ratio and therefore lower risk for certain health issues.'
const tlrDesc =
  'Similar to WHR where body shape is described using a ratio, but instead of waist and hips circumferences, body trunk/torso and leg volumes are used. By using volume it captures a more detailed view of body shape. A lower trunk to leg volume ratio generally means lower risk for certain health issues.'
const fatTotalDesc =
  'The total amount of fat in the body. There are multiple types of fat in the body which have very different effects on overall healthy. The body shape tab can provide more insight into how fat distribution factors into potential health risks.'
const leanDesc =
  'Lean mass is the muscle tissue, skeletal tissue, and water in the body. Lean mass burns more energy than fat mass, so increasing lean mass can help continue to reduce fat mass.'
const bmrShort = 'The amount of energy your body is burning while at rest.'
const bsrSummary =
  'Fit3D extracted SBSI, ABSI, Trunk to Leg Volume Ratio, body fat percentage, and BMI from more than 26,000 scans. Fit3D then evaluated the correlation between each algorithm and calculated the weighted values for the health risk outcomes based on the overall Fit3D user population. This results in a Body Shape Rating (BSR). A user can then understand how their body shape wellness compares with the rest of the Fit3D population.'
const bsrImprove =
  'The primary way to improve your BSR is to increase the density of your body, build the muscle in your legs, and decrease your waist circumference.'
const nutritionOrDoctors =
  'This can be done through a balanced mix of good nutrition and exercise. Consult with your trainer, nutritionist, coaches, or doctors to set up a plan.'
const absiRefs =
  'To better understand ABSI, SBSI, Body Fat Percentage and Trunk to Leg Volume Ratio, please refer to the descriptions below or the research from the following links:'
const tlrSummary =
  'Trunk to Leg Volume Ratio compares the volume of your trunk with the volume of your legs. This can generally only be done with some type of body scanning, whether it be Fit3D or more costly and complex scanners like DXA or MRI. Research claims that having a high percentage of your body’s volume in your torso compared to your legs increases the likelihood of you experiencing prediabetes, diabetes, high triglyceride (fat) counts, high blood pressure, metabolic syndromes, and other severe health complications.'
const visceralBelly =
  'Weight in your mid-section is highly correlated with visceral fat, which is the unhealthy fat around your organs. If you have a big belly and smaller legs, it is a good assumption that your weight is centered around your midsection and is therefore visceral fat.'
const tlrImprove =
  'This formula is dependent on volume, not weight. The overly simple way to improve your Trunk to Leg Volume score is to decrease the volume of your midsection and increase the volume of your legs.'
const hiitAndOr =
  'This can be done through a balanced mix of good nutrition and exercise that includes higher intensity interval training. Consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan'
const bfpResearch =
  'Through research partnerships with public and private institutions, Fit3D has scanned thousands of people with Fit3D and DXA systems side by side. Fit3D has subsequently created algorithms that utilize hundreds of measurements automatically extracted from these body scans to calculate a user’s body fat percentage.'
const bfpGlossary =
  'Body fat percentage is the user’s total fat mass divided by the total body mass. Fat is an essential component of the body and is necessary to maintain life and reproductive functions; however, too much body fat can negatively affect overall health or hormone levels. It also serves as an indicator of more serious health problems that could potentially be faced in the future. The'
const essentialFatRemainder =
  '(fat that is required to maintain life functions) is generally 10-13% for women and 2-5% for men (referenced through NASM).'
const decreaseBfp =
  'You can decrease your body fat percentage through a balanced mix of good nutrition and exercise that includes higher intensity interval training and cardio. Consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan.'
const weightGlossary =
  'Body weight is a person’s mass or weight. This is probably the easiest metric to measure on a human and is therefore a part of our primary assessment metrics; however, the body shape makeup and body composition is a much more real mechanism to determine the health of an individual.'
const fatMassLead =
  'Fat mass is also known as adipose tissue within the body. This loose connective tissue is primarily composed of'
const fatMassTrail =
  '. Its main role is to store energy in the form of lipids. It also cushions and insulates the body.'
const threeFatTypes = 'Body fat is primarily made up of three types of fat:'
const twoComponent =
  'The 2-component model, which consists of fat mass and lean mass calculations, is widely used to determine body composition. Fat mass is the mass of the adipose tissue in the body. Lean mass is the muscle tissue, skeletal tissue, and water in the body. In 3- and 4-component models, skeletal tissue and water are drawn out as isolated measurements.'
const increaseLean =
  'You can increase your lean mass by participating in fitness programs that include weight training. You can also talk with your nutritionist to develop a nutrition program that will effectively build lean mass. If you are simply looking to build lean mass, but not necessarily lose fat mass, your program may be quite different than a program that is geared towards a more balanced fat percentage reduction. Consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan.'
const wcRisk =
  'Waist circumference (WC) provides a prediction of risk independent of BMI. WC is particularly useful for patients who are categorized as normal or overweight on the BMI scale as a measurement associated with visceral fat and overall body shape.'
const wcHighRisk =
  'High risk is associated for men with WC > 102 cm and for women where WC > 88 cm.'
const wcSmall =
  'WC is the circumference measurement taken at the small of the back.'
const whrLimited =
  'This ratio as a health metric is extremely limited, but it is an easy way to try to evaluate the level of visceral fat one may have.'
const whrImprove =
  'While you cannot spot reduced fat mass throughout your body, you can still work with your coaches to reduce the amount throughout your body, which will generally decrease the circumference of your mid-section. WHR is extremely limited in scope, but is widely used as a metric of health.'
const whrConsult =
  'We suggest that you consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan before focusing solely on your WHR.'
const bmrSummary =
  'Basal Metabolic Rate (BMR) is the amount of energy expended while at rest in a neutrally temperate environment and in the post-absorptive state. In this state, the digestive system is inactive, which is usually achieved by about twelve hours of fasting. Furthermore, BMR is the amount of energy expressed in calories that a person needs to keep the body functioning (i.e. breathing, blood circulation, controlling body temperature, cell growth, brain and nervous function, and contraction of muscles). BMR affects the rate at which a person burns calories and ultimately affects whether that individual maintains, gains, or loses weight.'
const bmrImprove =
  'You can increase your BMR by participating in fitness programs that include high intensity interval training or lifting weights to build muscle. You can further increase your BMR by eating more protein, eating many smaller-portioned meals per day, and staying hydrated. The rule of thumb here is that muscle requires more energy to survive—the more lean muscle you have on your body, the higher your BMR. Consult with your trainer, nutritionist, coaches, and/or doctors to set up a plan.'
const bpLead = 'Blood pressure is the'
const bpUpon = 'exerted by circulating'
const bpUponWalls = 'upon the walls of'
const bpUsually = '. "Blood pressure" usually refers to the'
const bpInThe = 'pressure in the'
const bpVaries =
  '. Blood pressure varies depending on the environment, activity, and disease states and is regulated by the nervous and endocrine systems.'
const hrLead =
  "Heart rate is the speed of the heartbeat measured by the number of contractions of the heart per minute (bpm). The heart rate can vary according to the body's"
const hrNeeds = 'needs, including the need to absorb oxygen and excrete'
const hrNormal = '. The normal resting adult heart rate ranges from 60-100 bpm.'
const adiposeFormula =
  'The mass of the adipose tissue within the body is given by:'
const eatLabel = 'Epicardial Adipose Tissue (EAT)'
const whrRisk =
  'WHR is a ratio generally used to evaluate whether the individual is at high risk of obesity, diabetes, coronary heart disease, and/or high blood pressure. The measurement evaluates body shape in the midsection of the body.'

const glossaryPhrases = {
  [sampleImageNote]: {
    fr:
      "* Remarque : l'image d'exemple sert uniquement à afficher les emplacements de mesure et les parties du corps. Le tableau à droite affiche vos mesures.",
    de:
      '* Hinweis: Das Beispielbild dient nur dazu, Messpositionen und Körperteile anzuzeigen. Die Tabelle rechts zeigt Ihre Messwerte.',
    es:
      '* Nota: La imagen de ejemplo solo se usa para mostrar las ubicaciones de las medidas y las partes del cuerpo. La tabla de la derecha muestra tus medidas.',
    pt:
      '* Nota: A imagem de exemplo serve apenas para mostrar os locais de medição e as partes do corpo. A tabela à direita mostra as suas medidas.',
    zh_CN:
      '* 注意：示例图仅用于显示测量位置和身体部位。右侧表格显示您的测量值。',
    zh_TW:
      '* 注意：示例圖僅用於顯示測量位置與身體部位。右側表格顯示您的測量值。',
    it:
      "* Nota: l'immagine di esempio serve solo a mostrare le posizioni delle misure e le parti del corpo. La tabella a destra mostra le tue misure.",
    ko:
      '* 참고: 샘플 이미지는 측정 위치와 신체 부위를 보여 주기 위한 것입니다. 오른쪽 표에 측정값이 표시됩니다.',
    nl:
      '* Opmerking: de voorbeeldafbeelding toont alleen meetlocaties en lichaamsdelen. De tabel rechts toont uw metingen.',
    fi:
      '* Huom: Esimerkkikuvaa käytetään vain mittauskohtien ja kehonosien näyttämiseen. Oikeanpuoleinen taulukko näyttää mittasi.',
    ru:
      '* Примечание: образец изображения только показывает места измерений и части тела. Таблица справа содержит ваши измерения.',
    sv:
      '* Obs: Exempelbilden används bara för att visa mätpositioner och kroppsdelar. Tabellen till höger visar dina mått.',
    ja:
      '* 注: サンプル画像は測定位置と部位の表示専用です。右側の表に測定値が表示されます。',
    tr:
      '* Not: Örnek görüntü yalnızca ölçüm konumlarını ve vücut bölgelerini göstermek içindir. Sağdaki tablo ölçülerinizi gösterir.',
    cs:
      '* Poznámka: Ukázkový obrázek slouží jen k zobrazení míst měření a částí těla. Tabulka vpravo zobrazuje vaše míry.',
    el:
      '* Σημείωση: Η εικόνα δείγματος χρησιμοποιείται μόνο για θέσεις μέτρησης και μέρη του σώματος. Ο πίνακας δεξιά εμφανίζει τις μετρήσεις σας.',
    hr:
      '* Napomena: Ogledna slika služi samo za prikaz položaja mjerenja i dijelova tijela. Tablica desno prikazuje vaša mjerenja.',
  },
  [sampleImageClientNote]: {
    fr:
      "* Remarque : l'image d'exemple sert uniquement à afficher les emplacements de mesure et les parties du corps. Le tableau à droite affiche les mesures du client.",
    de:
      '* Hinweis: Das Beispielbild dient nur dazu, Messpositionen und Körperteile anzuzeigen. Die Tabelle rechts zeigt die Messwerte des Kunden.',
    es:
      '* Nota: La imagen de ejemplo solo se usa para mostrar las ubicaciones de las medidas y las partes del cuerpo. La tabla de la derecha muestra las medidas del cliente.',
    pt:
      '* Nota: A imagem de exemplo serve apenas para mostrar os locais de medição e as partes do corpo. A tabela à direita mostra as medidas do cliente.',
    zh_CN:
      '* 注意：示例图仅用于显示测量位置和身体部位。右侧表格显示客户的测量值。',
    zh_TW:
      '* 注意：示例圖僅用於顯示測量位置與身體部位。右側表格顯示客戶的測量值。',
    it:
      "* Nota: l'immagine di esempio serve solo a mostrare le posizioni delle misure e le parti del corpo. La tabella a destra mostra le misure del cliente.",
    ko:
      '* 참고: 샘플 이미지는 측정 위치와 신체 부위를 보여 주기 위한 것입니다. 오른쪽 표에 고객 측정값이 표시됩니다.',
    nl:
      '* Opmerking: de voorbeeldafbeelding toont alleen meetlocaties en lichaamsdelen. De tabel rechts toont de metingen van de klant.',
    fi:
      '* Huom: Esimerkkikuvaa käytetään vain mittauskohtien ja kehonosien näyttämiseen. Oikeanpuoleinen taulukko näyttää asiakkaan mitat.',
    ru:
      '* Примечание: образец изображения только показывает места измерений и части тела. Таблица справа содержит измерения клиента.',
    sv:
      '* Obs: Exempelbilden används bara för att visa mätpositioner och kroppsdelar. Tabellen till höger visar klientens mått.',
    ja:
      '* 注: サンプル画像は測定位置と部位の表示専用です。右側の表に顧客の測定値が表示されます。',
    tr:
      '* Not: Örnek görüntü yalnızca ölçüm konumlarını ve vücut bölgelerini göstermek içindir. Sağdaki tablo müşterinin ölçülerini gösterir.',
    cs:
      '* Poznámka: Ukázkový obrázek slouží jen k zobrazení míst měření a částí těla. Tabulka vpravo zobrazuje míry klienta.',
    el:
      '* Σημείωση: Η εικόνα δείγματος χρησιμοποιείται μόνο για θέσεις μέτρησης και μέρη του σώματος. Ο πίνακας δεξιά εμφανίζει τις μετρήσεις του πελάτη.',
    hr:
      '* Napomena: Ogledna slika služi samo za prikaz položaja mjerenja i dijelova tijela. Tablica desno prikazuje mjerenja klijenta.',
  },
  [userBfp]: {
    fr:
      "Le pourcentage de graisse corporelle est la masse grasse totale de l'utilisateur divisée par la masse corporelle totale. La graisse est essentielle, mais un excès peut nuire à la santé globale.",
    de:
      'Der Körperfettanteil ist die gesamte Fettmasse geteilt durch die Gesamtkörpermasse. Fett ist essenziell, zu viel Körperfett kann die Gesundheit jedoch negativ beeinflussen.',
    es:
      'El porcentaje de grasa corporal es la masa grasa total del usuario dividida por la masa corporal total. La grasa es esencial; sin embargo, demasiada puede afectar negativamente la salud.',
    pt:
      'O percentual de gordura corporal é a massa gorda total do usuário dividida pela massa corporal total. A gordura é essencial, mas o excesso pode prejudicar a saúde.',
    zh_CN:
      '体脂百分比等于用户脂肪总量除以总体重。脂肪是身体必需成分，但过多会损害整体健康。',
    zh_TW:
      '體脂百分比等於使用者脂肪總量除以總體重。脂肪是身體必需成分，但過多會損害整體健康。',
    it:
      "La percentuale di grasso corporeo è la massa grassa totale dell'utente divisa per la massa corporea totale. Il grasso è una componente essenziale del corpo; tuttavia, una quantità eccessiva può influire negativamente sulla salute generale.",
    ko:
      '체지방률은 사용자의 총 지방량을 총 체중으로 나눈 값입니다. 지방은 필수이지만 너무 많으면 전반적 건강에 해롭습니다.',
    nl:
      'Het lichaamsvetpercentage is de totale vetmassa gedeeld door de totale lichaamsmassa. Vet is essentieel, maar te veel kan de gezondheid schaden.',
    fi:
      'Rasvaprosentti on käyttäjän rasvamassa jaettuna kokonaispainolla. Rasva on välttämätöntä, mutta liika rasva voi heikentää terveyttä.',
    ru:
      'Процент жира — это жировая масса, делённая на общую массу тела. Жир необходим, но его избыток вреден для здоровья.',
    sv:
      'Kroppsfettprocenten är användarens fettmassa dividerad med den totala kroppsmassan. Fett är nödvändigt, men för mycket kan påverka hälsan negativt.',
    ja:
      '体脂肪率は脂肪量を体重で割った値です。脂肪は不可欠ですが、多すぎると健康に悪影響があります。',
    tr:
      'Vücut yağ yüzdesi, toplam yağ kütlesinin toplam vücut kütlesine bölünmesidir. Yağ gereklidir ancak fazlası sağlığı olumsuz etkiler.',
    cs:
      'Procento tělesného tuku je tuková hmota dělená celkovou tělesnou hmotností. Tuk je nezbytný, ale jeho nadbytek škodí zdraví.',
    el:
      'Το ποσοστό σωματικού λίπους είναι η λιπώδης μάζα διά τη συνολική μάζα σώματος. Το λίπος είναι απαραίτητο, αλλά η υπερβολή βλάπτει την υγεία.',
    hr:
      'Postotak tjelesne masti je masna masa podijeljena s ukupnom tjelesnom masom. Mast je nužna, ali previše narušava zdravlje.',
  },
  [personWeight]: {
    fr: "Le poids corporel est la masse ou le poids d'une personne.",
    de: 'Das Körpergewicht ist die Masse oder das Gewicht einer Person.',
    es: 'El peso corporal es la masa o el peso de una persona.',
    pt: 'O peso corporal é a massa ou o peso de uma pessoa.',
    zh_CN: '体重是一个人的质量或重量。',
    zh_TW: '體重是一個人的質量或重量。',
    it: 'Il peso corporeo è la massa o il peso di una persona.',
    ko: '체중은 사람의 질량 또는 무게입니다.',
    nl: 'Lichaamsgewicht is de massa of het gewicht van een persoon.',
    fi: 'Kehonpaino on henkilön massa tai paino.',
    ru: 'Вес тела — это масса или вес человека.',
    sv: 'Kroppsvikten är en persons massa eller vikt.',
    ja: '体重はその人の質量または重さです。',
    tr: 'Vücut ağırlığı bir kişinin kütlesi veya ağırlığıdır.',
    cs: 'Tělesná hmotnost je hmotnost nebo váha osoby.',
    el: 'Το σωματικό βάρος είναι η μάζα ή το βάρος ενός ατόμου.',
    hr: 'Tjelesna težina je masa ili težina osobe.',
  },
  [waistDesc]: {
    fr:
      'Un tour de taille plus élevé peut indiquer davantage de graisse « profonde » (viscérale), un type de graisse nocif autour des organes internes. En général, un tour de taille plus faible est préférable. Il a longtemps été utilisé pour sa simplicité.',
    de:
      'Ein größerer Taillenumfang kann auf mehr „tiefes“ (viszerales) Fett hinweisen, das innere Organe umhüllt. Im Allgemeinen ist ein geringerer Umfang besser. Der Taillenumfang wurde wegen seiner Einfachheit häufig verwendet.',
    es:
      'Una circunferencia de cintura mayor puede indicar más grasa “profunda” (visceral) alrededor de órganos internos. En general, una circunferencia menor es mejor. Se ha usado mucho por su sencillez.',
    pt:
      'Uma circunferência da cintura maior pode indicar mais gordura “profunda” (visceral) em volta dos órgãos. Em geral, uma circunferência menor é melhor. Foi muito usada pela simplicidade.',
    zh_CN:
      '腰围较大可能意味着更多“深层”（内脏）脂肪。一般来说腰围越小越好。腰围因测量简单而被广泛使用。',
    zh_TW:
      '腰圍較大可能代表較多「深層」（內臟）脂肪。一般而言腰圍越小越好。腰圍因測量簡單而被廣泛使用。',
    it:
      'Una circonferenza vita maggiore può indicare una maggiore quantità di grasso "profondo" (viscerale) intorno agli organi interni. In generale una circonferenza più bassa è preferibile. È stata usata a lungo per la sua semplicità.',
    ko:
      '허리둘레가 클수록 “깊은”(내장) 지방이 더 많을 수 있습니다. 일반적으로 작을수록 좋습니다. 측정이 간단해 널리 쓰였습니다.',
    nl:
      'Een grotere tailleomtrek kan wijzen op meer “diep” (visceraal) vet rond organen. Over het algemeen is een kleinere omtrek beter. Het werd vaak gebruikt vanwege de eenvoud.',
    fi:
      'Suurempi vyötärönympärys voi tarkoittaa enemmän ”syvää” (viskeraalista) rasvaa. Yleensä pienempi ympärys on parempi. Sitä on käytetty paljon yksinkertaisuuden vuoksi.',
    ru:
      'Большая окружность талии может означать больше «глубокого» (висцерального) жира вокруг органов. Как правило, меньшая окружность лучше. Показатель широко использовали из‑за простоты.',
    sv:
      'Ett större midjemått kan betyda mer ”djupt” (visceralt) fett runt inre organ. Generellt är ett mindre mått bättre. Det har använts mycket på grund av sin enkelhet.',
    ja:
      '腹囲が大きいと内臓を包む「深い」脂肪が多い可能性があります。一般に小さい方が望ましいです。測定が簡単なため広く使われてきました。',
    tr:
      'Daha büyük bel çevresi, organları saran daha fazla “derin” (viseral) yağ anlamına gelebilir. Genel olarak daha düşük bel çevresi daha iyidir. Ölçümü kolay olduğu için yaygın kullanılmıştır.',
    cs:
      'Větší obvod pasu může znamenat více „hlubokého“ (viscerálního) tuku kolem orgánů. Obecně je nižší obvod lepší. Používal se hojně pro svou jednoduchost.',
    el:
      'Μεγαλύτερη περίμετρος μέσης μπορεί να σημαίνει περισσότερο «βαθύ» (σπλαχνικό) λίπος γύρω από όργανα. Γενικά μικρότερη περίμετρος είναι καλύτερη. Χρησιμοποιήθηκε ευρέως λόγω απλότητας.',
    hr:
      'Veći opseg struka može značiti više „duboke“ (visceralne) masti oko organa. Općenito je manji opseg bolji. Često se koristio zbog jednostavnosti.',
  },
  [whrDesc]: {
    fr:
      'Le rapport taille-hanches décrit la forme corporelle. Un rapport plus bas indique généralement un risque moindre. Les silhouettes « pomme » et « poire » sont les deux extrémités du spectre WHR.',
    de:
      'Das Taille-Hüft-Verhältnis beschreibt die Körperform. Ein niedrigeres Verhältnis bedeutet in der Regel geringeres Risiko. Apfel- und Birnenform sind die Enden des WHR-Spektrums.',
    es:
      'El índice cintura-cadera describe la forma corporal. Un índice más bajo suele implicar menor riesgo. Las formas manzana y pera son los extremos del espectro WHR.',
    pt:
      'A relação cintura-quadril descreve a forma corporal. Uma relação menor geralmente significa menor risco. As formas maçã e pera são os extremos do espectro WHR.',
    zh_CN:
      '腰臀比用腰围与臀围的比值描述体型。比值越低，某些健康风险通常越低。苹果形与梨形是 WHR 的两端。',
    zh_TW:
      '腰臀比用腰圍與臀圍的比值描述體型。比值越低，某些健康風險通常越低。蘋果形與梨形是 WHR 的兩端。',
    it:
      'Il rapporto vita-fianchi descrive la forma del corpo. Un rapporto più basso indica generalmente un minor rischio. Le forme a mela e a pera sono gli estremi dello spettro WHR.',
    ko:
      '허리-엉덩이 비율은 체형을 나타냅니다. 비율이 낮을수록 특정 건강 위험이 일반적으로 낮습니다. 사과형과 배형은 WHR 스펙트럼의 양 끝입니다.',
    nl:
      'De taille-heupverhouding beschrijft lichaamsvorm. Een lagere verhouding betekent meestal minder risico. Appel- en peervorm zijn de uiteinden van het WHR-spectrum.',
    fi:
      'Vyötärö-lantiosuhde kuvaa kehon muotoa. Pienempi suhde merkitsee yleensä pienempää riskiä. Omena- ja päärynämuoto ovat WHR-kirjon ääripäät.',
    ru:
      'Отношение талии к бёдрам описывает форму тела. Более низкое отношение обычно означает меньший риск. Формы «яблоко» и «груша» — края спектра WHR.',
    sv:
      'Midja-höftkvoten beskriver kroppsformen. En lägre kvot betyder vanligtvis lägre risk. Äpple- och päronform är ändarna av WHR-spektrumet.',
    ja:
      'ウエストヒップ比は体型を表します。比が低いほどリスクは一般に低くなります。リンゴ型と洋ナシ型は WHR の両端です。',
    tr:
      'Bel-kalça oranı vücut şeklini tanımlar. Daha düşük oran genellikle daha düşük risk demektir. Elma ve armut şekilleri WHR spektrumunun iki ucudur.',
    cs:
      'Poměr pas-boky popisuje tvar těla. Nižší poměr obvykle znamená nižší riziko. Tvary jablko a hruška jsou konce spektra WHR.',
    el:
      'Ο λόγος μέσης-ισχίων περιγράφει το σχήμα σώματος. Χαμηλότερος λόγος σημαίνει γενικά χαμηλότερο κίνδυνο. Μήλο και αχλάδι είναι τα άκρα του φάσματος WHR.',
    hr:
      'Omjer struka i bokova opisuje oblik tijela. Niži omjer obično znači manji rizik. Oblici jabuka i kruška su krajevi spektra WHR.',
  },
  [tlrDesc]: {
    fr:
      'Comme le WHR, mais avec les volumes du tronc et des jambes plutôt que les circonférences. Un rapport plus bas indique généralement un risque moindre.',
    de:
      'Ähnlich wie WHR, jedoch mit Rumpf- und Beinvolumen statt Umfängen. Ein niedrigeres Verhältnis bedeutet in der Regel geringeres Risiko.',
    es:
      'Similar al WHR, pero usa volúmenes de tronco y piernas en lugar de circunferencias. Un valor más bajo suele implicar menor riesgo.',
    pt:
      'Semelhante ao WHR, mas usa volumes de tronco e pernas em vez de circunferências. Um valor menor geralmente significa menor risco.',
    zh_CN:
      '与 WHR 类似，但用躯干和腿部体积而非围度。比值越低，某些健康风险通常越低。',
    zh_TW:
      '與 WHR 類似，但用軀幹與腿部體積而非圍度。比值越低，某些健康風險通常越低。',
    it:
      'Analogamente al WHR, ma con i volumi di tronco e gambe. Un rapporto più basso indica generalmente un minor rischio.',
    ko:
      'WHR과 비슷하지만 둘레 대신 몸통과 다리 부피를 씁니다. 비율이 낮을수록 위험이 일반적으로 낮습니다.',
    nl:
      'Vergelijkbaar met WHR, maar met romp- en beenvolume in plaats van omtrekken. Een lagere verhouding betekent meestal minder risico.',
    fi:
      'Kuten WHR, mutta vyötärön ja lantion sijaan käytetään vartalon ja jalkojen tilavuutta. Pienempi suhde merkitsee yleensä pienempää riskiä.',
    ru:
      'Как WHR, но вместо обхватов используются объёмы туловища и ног. Более низкое отношение обычно означает меньший риск.',
    sv:
      'Liknar WHR, men använder volym i bål och ben. En lägre kvot betyder vanligtvis lägre risk.',
    ja:
      'WHR と同様ですが、周囲ではなく体幹と脚の体積を使います。比が低いほどリスクは一般に低くなります。',
    tr:
      'WHR’ye benzer, ancak bel ve kalça yerine gövde ve bacak hacimleri kullanılır. Daha düşük oran genellikle daha düşük risktir.',
    cs:
      'Podobné WHR, ale místo obvodů se používají objemy trupu a nohou. Nižší poměr obvykle znamená nižší riziko.',
    el:
      'Παρόμοιο με το WHR, αλλά με όγκους κορμού και ποδιών. Χαμηλότερος λόγος σημαίνει γενικά χαμηλότερο κίνδυνο.',
    hr:
      'Slično WHR-u, ali umjesto opsega koriste se volumeni trupa i nogu. Niži omjer obično znači manji rizik.',
  },
  [fatTotalDesc]: {
    fr:
      'La quantité totale de graisse dans le corps. Les différents types de graisse n’ont pas les mêmes effets. L’onglet forme corporelle précise la répartition et les risques.',
    de:
      'Die gesamte Fettmenge im Körper. Verschiedene Fettarten wirken sehr unterschiedlich. Der Tab Körperform gibt Hinweise zur Verteilung und zu Risiken.',
    es:
      'La cantidad total de grasa en el cuerpo. Hay varios tipos con efectos muy distintos. La pestaña de forma corporal aporta más sobre la distribución y los riesgos.',
    pt:
      'A quantidade total de gordura no corpo. Há vários tipos com efeitos muito diferentes. A aba de forma corporal detalha a distribuição e os riscos.',
    zh_CN:
      '体内脂肪总量。不同类型的脂肪对健康影响差别很大。体型页可帮助了解脂肪分布与风险。',
    zh_TW:
      '體內脂肪總量。不同類型的脂肪對健康影響差別很大。體型頁可協助了解脂肪分布與風險。',
    it:
      'La quantità totale di grasso nel corpo. Esistono diversi tipi di grasso, con effetti molto diversi. La scheda Forma corporea fornisce maggiori informazioni sulla distribuzione e sui rischi.',
    ko:
      '체내 지방 총량입니다. 지방 종류마다 건강에 미치는 영향이 다릅니다. 체형 탭에서 분포와 위험을 더 볼 수 있습니다.',
    nl:
      'De totale hoeveelheid vet in het lichaam. Verschillende soorten vet hebben zeer verschillende effecten. Het tabblad lichaamsvorm geeft meer inzicht in verdeling en risico’s.',
    fi:
      'Kehon rasvan kokonaismäärä. Rasvatyypeillä on hyvin erilaisia vaikutuksia. Kehonmuoto-välilehti kertoo jakautumisesta ja riskeistä.',
    ru:
      'Общее количество жира в теле. Разные типы жира влияют на здоровье по-разному. Вкладка формы тела поясняет распределение и риски.',
    sv:
      'Den totala mängden fett i kroppen. Olika fetttyper påverkar hälsan mycket olika. Fliken kroppsform ger mer om fördelning och risker.',
    ja:
      '体内の脂肪の総量です。脂肪の種類によって健康への影響は大きく異なります。体型タブで分布とリスクを確認できます。',
    tr:
      'Vücuttaki toplam yağ miktarı. Yağ türlerinin sağlık etkileri çok farklıdır. Vücut şekli sekmesi dağılım ve riskler hakkında daha fazla bilgi verir.',
    cs:
      'Celkové množství tuku v těle. Různé typy tuku mají velmi odlišné účinky. Karta tvaru těla objasňuje rozložení a rizika.',
    el:
      'Η συνολική ποσότητα λίπους στο σώμα. Τα είδη λίπους έχουν πολύ διαφορετικές επιδράσεις. Η καρτέλα σχήματος σώματος δείχνει κατανομή και κινδύνους.',
    hr:
      'Ukupna količina masti u tijelu. Različite vrste masti imaju vrlo različite učinke. Kartica oblika tijela daje uvid u raspodjelu i rizike.',
  },
  [leanDesc]: {
    fr:
      'La masse maigre comprend muscle, squelette et eau. Elle brûle plus d’énergie que la masse grasse ; l’augmenter aide à réduire la graisse.',
    de:
      'Magermasse umfasst Muskel, Skelett und Wasser. Sie verbraucht mehr Energie als Fettmasse; sie zu erhöhen hilft, Fett zu reduzieren.',
    es:
      'La masa magra es músculo, esqueleto y agua. Quema más energía que la masa grasa, así que aumentarla ayuda a seguir reduciendo grasa.',
    pt:
      'A massa magra é músculo, esqueleto e água. Queima mais energia do que a massa gorda; aumentá-la ajuda a reduzir gordura.',
    zh_CN:
      '瘦体重包括肌肉、骨骼和组织水。它比脂肪消耗更多能量，增加瘦体重有助于继续减脂。',
    zh_TW:
      '瘦體重包括肌肉、骨骼與組織水。它比脂肪消耗更多能量，增加瘦體重有助於繼續減脂。',
    it:
      'La massa magra comprende tessuto muscolare, scheletrico e acqua. Consuma più energia della massa grassa, quindi aumentarla aiuta a ridurre il grasso.',
    ko:
      '제지방량은 근육, 골격, 수분입니다. 지방보다 에너지를 더 쓰므로 늘리면 지방 감소에 도움이 됩니다.',
    nl:
      'Magere massa is spier, skelet en water. Het verbrandt meer energie dan vetmassa; meer magere massa helpt vet te verminderen.',
    fi:
      'Rasvaton massa on lihas, luusto ja vesi. Se kuluttaa enemmän energiaa kuin rasva, joten sen lisääminen auttaa vähentämään rasvaa.',
    ru:
      'Тощая масса — мышцы, скелет и вода. Она тратит больше энергии, чем жир, поэтому её рост помогает снижать жир.',
    sv:
      'Fettfri massa är muskel, skelett och vatten. Den förbränner mer energi än fettmassa, så mer av den hjälper till att minska fett.',
    ja:
      '除脂肪量は筋肉・骨格・水分です。脂肪より多くのエネルギーを使うため、増やすと減脂に役立ちます。',
    tr:
      'Yağsız kütle kas, iskelet ve sudur. Yağdan daha fazla enerji yakar; artırmak yağın azalmasına yardımcı olur.',
    cs:
      'Hubená hmota je sval, kostra a voda. Spaluje více energie než tuk, proto její nárůst pomáhá snižovat tuk.',
    el:
      'Η άλιπη μάζα είναι μυς, σκελετός και νερό. Καίει περισσότερη ενέργεια από το λίπος, οπότε η αύξησή της βοηθά στη μείωση λίπους.',
    hr:
      'Mršava masa su mišić, kostur i voda. Troši više energije od masne mase, pa njezino povećanje pomaže smanjiti mast.',
  },
  [bsrSummary]: {
    fr:
      'Fit3D a extrait SBSI, ABSI, le rapport de volume tronc-jambes, le pourcentage de graisse corporelle et l’IMC de plus de 26 000 scans, puis a pondéré les risques de santé selon la population Fit3D. Il en résulte un Body Shape Rating (BSR), pour comparer votre forme au reste des utilisateurs Fit3D.',
    de:
      'Fit3D hat SBSI, ABSI, das Rumpf-Bein-Volumenverhältnis, den Körperfettanteil und den BMI aus mehr als 26.000 Scans ermittelt und die Gesundheitsrisiken anhand der Fit3D-Nutzerpopulation gewichtet. Daraus entsteht ein Body Shape Rating (BSR), mit dem Sie Ihre Körperform mit der übrigen Fit3D-Bevölkerung vergleichen können.',
    es:
      'Fit3D extrajo SBSI, ABSI, la relación de volumen tronco-piernas, el porcentaje de grasa corporal y el IMC de más de 26.000 escaneos y ponderó los riesgos de salud según la población Fit3D. El resultado es un Body Shape Rating (BSR) para comparar tu forma corporal con el resto de usuarios Fit3D.',
    pt:
      'A Fit3D extraiu SBSI, ABSI, a relação de volume tronco-pernas, o percentual de gordura e o IMC de mais de 26.000 scans e ponderou os riscos de saúde pela população Fit3D. O resultado é um Body Shape Rating (BSR) para comparar a sua forma com os restantes utilizadores Fit3D.',
    zh_CN:
      'Fit3D 从超过 26,000 次扫描中提取了 SBSI、ABSI、躯干-腿部体积比、体脂率和 BMI，并按 Fit3D 用户群体加权健康风险，得到体型评分（BSR），便于与其他用户比较。',
    zh_TW:
      'Fit3D 從超過 26,000 次掃描中提取 SBSI、ABSI、軀幹-腿部體積比、體脂率與 BMI，並依 Fit3D 使用者族群加權健康風險，得到體型評分（BSR），以便與其他使用者比較。',
    it:
      'Fit3D ha estratto SBSI, ABSI, il rapporto di volume tronco-gambe, la percentuale di grasso corporeo e il BMI da oltre 26.000 scansioni, poi ha ponderato i rischi per la salute sulla popolazione Fit3D. Ne risulta un Body Shape Rating (BSR) per confrontare la propria forma con il resto degli utenti Fit3D.',
    ko:
      'Fit3D는 26,000건 이상의 스캔에서 SBSI, ABSI, 몸통-다리 부피 비율, 체지방률, BMI를 추출하고 Fit3D 사용자 집단을 기준으로 건강 위험을 가중해 체형 점수(BSR)를 산출합니다. 이를 통해 다른 사용자와 체형을 비교할 수 있습니다.',
    nl:
      'Fit3D extraheerde SBSI, ABSI, de romp-beenvolumeverhouding, lichaamsvetpercentage en BMI uit meer dan 26.000 scans en woog gezondheidsrisico’s op de Fit3D-populatie. Dat levert een Body Shape Rating (BSR) op om uw lichaamsvorm te vergelijken met andere gebruikers.',
    fi:
      'Fit3D poimi SBSI:n, ABSI:n, vartalo–jalka-tilavuussuhteen, rasvaprosentin ja BMI:n yli 26 000 skannauksesta ja painotti terveysriskejä Fit3D-käyttäjäkannan mukaan. Tuloksena on Body Shape Rating (BSR), jolla voit verrata kehonmuotoasi muihin.',
    ru:
      'Fit3D извлекла SBSI, ABSI, отношение объёма туловища к ногам, процент жира и ИМТ из более чем 26 000 сканов и взвесила риски по популяции Fit3D. Так получается Body Shape Rating (BSR) для сравнения формы тела с другими пользователями.',
    sv:
      'Fit3D extraherade SBSI, ABSI, volymförhållandet bål–ben, kroppsfettprocent och BMI från mer än 26 000 skanningar och viktade hälsorisker mot Fit3D-populationen. Resultatet är ett Body Shape Rating (BSR) för att jämföra din kroppsform med andra användare.',
    ja:
      'Fit3D は 26,000 件超のスキャンから SBSI、ABSI、体幹対脚体積比、体脂肪率、BMI を抽出し、Fit3D 利用者全体で健康リスクを重み付けして体型スコア（BSR）を算出します。他の利用者と比較して体型を把握できます。',
    tr:
      'Fit3D, 26.000’den fazla taramadan SBSI, ABSI, gövde-bacak hacim oranı, vücut yağ yüzdesi ve BMI çıkardı ve sağlık risklerini Fit3D kullanıcı kitlesine göre ağırlıklandırdı. Sonuç, vücut şeklinizi diğer kullanıcılarla karşılaştırmanızı sağlayan Body Shape Rating (BSR)’dir.',
    cs:
      'Fit3D z více než 26 000 skenů extrahovala SBSI, ABSI, poměr objemu trupu k nohám, procento tuku a BMI a vážila zdravotní rizika podle populace Fit3D. Výsledkem je Body Shape Rating (BSR) pro srovnání tvaru těla s ostatními uživateli.',
    el:
      'Η Fit3D εξήγαγε SBSI, ABSI, αναλογία όγκου κορμού-ποδιών, ποσοστό λίπους και ΔΜΣ από πάνω από 26.000 σαρώσεις και στάθμισε κινδύνους υγείας στον πληθυσμό Fit3D. Προκύπτει Body Shape Rating (BSR) για σύγκριση του σχήματος σώματος με άλλους χρήστες.',
    hr:
      'Fit3D je iz više od 26.000 skenova izdvojio SBSI, ABSI, omjer volumena trupa i nogu, postotak masti i BMI te ponderirao zdravstvene rizike prema Fit3D populaciji. Rezultat je Body Shape Rating (BSR) za usporedbu oblika tijela s ostalim korisnicima.',
  },
  [bsrImprove]: {
    fr:
      'Le principal moyen d’améliorer votre BSR est d’augmenter la densité corporelle, de muscler les jambes et de réduire le tour de taille.',
    de:
      'Der wichtigste Weg, Ihren BSR zu verbessern, ist, die Körperdichte zu erhöhen, die Beinmuskulatur aufzubauen und den Taillenumfang zu senken.',
    es:
      'La forma principal de mejorar tu BSR es aumentar la densidad corporal, desarrollar el músculo de las piernas y reducir la circunferencia de cintura.',
    pt:
      'A principal forma de melhorar o BSR é aumentar a densidade corporal, desenvolver o músculo das pernas e diminuir a circunferência da cintura.',
    zh_CN: '改善 BSR 的主要方法是提高身体密度、增强腿部肌肉并减小腰围。',
    zh_TW: '改善 BSR 的主要方法是提高身體密度、增強腿部肌肉並縮小腰圍。',
    it:
      'Il modo principale per migliorare il BSR è aumentare la densità corporea, sviluppare i muscoli delle gambe e ridurre la circonferenza vita.',
    ko:
      'BSR을 개선하는 주된 방법은 신체 밀도를 높이고 다리 근육을 키우며 허리둘레를 줄이는 것입니다.',
    nl:
      'De belangrijkste manier om uw BSR te verbeteren is de lichaamsdichtheid te verhogen, beenspieren op te bouwen en de tailleomtrek te verlagen.',
    fi:
      'Tärkein tapa parantaa BSR:ää on lisätä kehon tiheyttä, kasvattaa jalkojen lihaksia ja pienentää vyötärönympärystä.',
    ru:
      'Главный способ улучшить BSR — повысить плотность тела, нарастить мышцы ног и уменьшить окружность талии.',
    sv:
      'Det främsta sättet att förbättra BSR är att öka kroppens täthet, bygga benmuskler och minska midjemåttet.',
    ja:
      'BSR を改善する主な方法は、身体密度を高め、脚の筋肉をつけ、腹囲を減らすことです。',
    tr:
      'BSR’nizi iyileştirmenin başlıca yolu vücut yoğunluğunu artırmak, bacak kaslarını geliştirmek ve bel çevresini azaltmaktır.',
    cs:
      'Hlavní způsob, jak zlepšit BSR, je zvýšit hustotu těla, posílit svaly nohou a snížit obvod pasu.',
    el:
      'Ο κύριος τρόπος βελτίωσης του BSR είναι να αυξήσετε την πυκνότητα του σώματος, να χτίσετε μυς στα πόδια και να μειώσετε την περίμετρο μέσης.',
    hr:
      'Glavni način poboljšanja BSR-a je povećati gustoću tijela, izgraditi mišiće nogu i smanjiti opseg struka.',
  },
  [nutritionOrDoctors]: {
    fr:
      'Cela passe par un mélange équilibré d’alimentation et d’exercice. Consultez votre coach, nutritionniste, entraîneurs ou médecins pour un plan.',
    de:
      'Das gelingt durch eine ausgewogene Mischung aus Ernährung und Bewegung. Sprechen Sie mit Trainer, Ernährungsberater, Coaches oder Ärzten über einen Plan.',
    es:
      'Se logra con una mezcla equilibrada de nutrición y ejercicio. Consulta con tu entrenador, nutricionista, coaches o médicos para armar un plan.',
    pt:
      'Isso faz-se com uma mistura equilibrada de nutrição e exercício. Consulte o seu treinador, nutricionista, coaches ou médicos para definir um plano.',
    zh_CN: '可通过均衡的营养和运动实现。请与教练、营养师或医生一起制定计划。',
    zh_TW: '可透過均衡的營養與運動實現。請與教練、營養師或醫師一起制定計畫。',
    it:
      'Si ottiene con un mix equilibrato di alimentazione ed esercizio. Consulta trainer, nutrizionista, coach o medici per un piano.',
    ko:
      '균형 잡힌 영양과 운동으로 가능합니다. 트레이너, 영양사, 코치 또는 의사와 상담해 계획을 세우세요.',
    nl:
      'Dit kan met een evenwichtige mix van voeding en beweging. Overleg met trainer, voedingsdeskundige, coaches of artsen voor een plan.',
    fi:
      'Tämä onnistuu tasapainoisella ravinnolla ja liikunnalla. Laadi suunnitelma valmentajan, ravitsemusterapeutin, coachien tai lääkäreiden kanssa.',
    ru:
      'Это достигается сочетанием питания и нагрузок. Составьте план с тренером, нутрициологом, коучами или врачами.',
    sv:
      'Det görs med en balanserad mix av kost och träning. Rådgör med tränare, nutritionist, coacher eller läkare för en plan.',
    ja:
      'バランスの取れた栄養と運動で実現できます。トレーナー、栄養士、コーチ、医師と計画を立ててください。',
    tr:
      'Dengeli beslenme ve egzersizle yapılabilir. Plan için antrenör, diyetisyen, koçlar veya doktorlarla görüşün.',
    cs:
      'Lze toho dosáhnout vyváženou stravou a cvičením. Plán sestavte s trenérem, výživovým poradcem, kouči nebo lékaři.',
    el:
      'Γίνεται με ισορροπημένη διατροφή και άσκηση. Συμβουλευτείτε προπονητή, διατροφολόγο, coaches ή γιατρούς για πλάνο.',
    hr:
      'To se postiže uravnoteženom prehranom i vježbanjem. Dogovorite plan s trenerom, nutricionistom, coachovima ili liječnicima.',
  },
  [absiRefs]: {
    fr:
      'Pour mieux comprendre ABSI, SBSI, le pourcentage de graisse corporelle et le rapport tronc-jambes, consultez les descriptions ci-dessous ou les recherches aux liens suivants :',
    de:
      'Um ABSI, SBSI, Körperfettanteil und Rumpf-Bein-Volumenverhältnis besser zu verstehen, lesen Sie die Beschreibungen unten oder die Forschung unter folgenden Links:',
    es:
      'Para entender mejor ABSI, SBSI, el porcentaje de grasa corporal y la relación tronco-piernas, consulta las descripciones abajo o la investigación de estos enlaces:',
    pt:
      'Para compreender melhor ABSI, SBSI, o percentual de gordura e a relação tronco-pernas, consulte as descrições abaixo ou a investigação nestes links:',
    zh_CN:
      '要更好理解 ABSI、SBSI、体脂率和躯干-腿部体积比，请参阅下方说明或以下研究链接：',
    zh_TW:
      '要更好理解 ABSI、SBSI、體脂率與軀幹-腿部體積比，請參閱下方說明或以下研究連結：',
    it:
      'Per comprendere meglio ABSI, SBSI, percentuale di grasso e rapporto tronco-gambe, consulta le descrizioni sotto o la ricerca ai seguenti link:',
    ko:
      'ABSI, SBSI, 체지방률, 몸통-다리 부피 비율을 더 이해하려면 아래 설명이나 다음 연구 링크를 참고하세요:',
    nl:
      'Voor ABSI, SBSI, lichaamsvetpercentage en romp-beenvolume, zie de beschrijvingen hieronder of het onderzoek via deze links:',
    fi:
      'ABSI:n, SBSI:n, rasvaprosentin ja vartalo–jalka-suhteen ymmärtämiseksi katso kuvaukset alla tai tutkimus seuraavista linkeistä:',
    ru:
      'Чтобы лучше понять ABSI, SBSI, процент жира и отношение туловища к ногам, см. описания ниже или исследования по ссылкам:',
    sv:
      'För att bättre förstå ABSI, SBSI, kroppsfettprocent och volymförhållande bål–ben, se beskrivningarna nedan eller forskningen via följande länkar:',
    ja:
      'ABSI、SBSI、体脂肪率、体幹対脚体積比をより理解するには、以下の説明または次の研究リンクを参照してください：',
    tr:
      'ABSI, SBSI, vücut yağ yüzdesi ve gövde-bacak hacim oranını daha iyi anlamak için aşağıdaki açıklamalara veya şu araştırma bağlantılarına bakın:',
    cs:
      'Pro lepší pochopení ABSI, SBSI, procenta tuku a poměru trupu k nohám viz popisy níže nebo výzkum na těchto odkazech:',
    el:
      'Για καλύτερη κατανόηση των ABSI, SBSI, ποσοστού λίπους και αναλογίας κορμού-ποδιών, δείτε τις περιγραφές παρακάτω ή την έρευνα στους συνδέσμους:',
    hr:
      'Za bolje razumijevanje ABSI, SBSI, postotka masti i omjera trupa i nogu pogledajte opise ispod ili istraživanje na sljedećim poveznicama:',
  },
  [tlrSummary]: {
    fr:
      'Le rapport de volume tronc-jambes compare le volume du tronc à celui des jambes. Cela nécessite généralement un scan corporel (Fit3D, DXA ou IRM). Un volume élevé dans le torse par rapport aux jambes est associé à un risque accru de prédiabète, diabète, triglycérides élevés, hypertension et syndromes métaboliques.',
    de:
      'Das Rumpf-Bein-Volumenverhältnis vergleicht das Rumpfvolumen mit dem Beinvolumen. Dafür braucht man in der Regel einen Körperscan (Fit3D, DXA oder MRT). Ein hoher Anteil des Volumens im Rumpf gegenüber den Beinen erhöht u. a. das Risiko für Prädiabetes, Diabetes, hohe Triglyceride, Bluthochdruck und metabolische Syndrome.',
    es:
      'La relación de volumen tronco-piernas compara el volumen del tronco con el de las piernas. Suele requerir un escaneo corporal (Fit3D, DXA o RM). Un alto porcentaje de volumen en el torso frente a las piernas aumenta la probabilidad de prediabetes, diabetes, triglicéridos altos, hipertensión y síndromes metabólicos.',
    pt:
      'A relação de volume tronco-pernas compara o volume do tronco com o das pernas. Em geral só é possível com um scan corporal (Fit3D, DXA ou RM). Uma percentagem alta de volume no tronco face às pernas aumenta a probabilidade de pré-diabetes, diabetes, triglicéridos altos, hipertensão e síndromes metabólicas.',
    zh_CN:
      '躯干-腿部体积比比较躯干与双腿体积，通常需要体扫（Fit3D、DXA 或 MRI）。躯干体积相对腿部偏高，与糖尿病前期、糖尿病、高甘油三酯、高血压和代谢综合征等相关。',
    zh_TW:
      '軀幹-腿部體積比比較軀幹與雙腿體積，通常需要體掃（Fit3D、DXA 或 MRI）。軀幹體積相對腿部偏高，與糖尿病前期、糖尿病、高三酸甘油酯、高血壓與代謝症候群等有關。',
    it:
      'Il rapporto di volume tronco-gambe confronta il volume del tronco con quello delle gambe. In genere richiede una scansione (Fit3D, DXA o RM). Una percentuale elevata di volume nel busto rispetto alle gambe aumenta la probabilità di prediabete, diabete, trigliceridi alti, pressione alta e sindromi metaboliche.',
    ko:
      '몸통-다리 부피 비율은 몸통과 다리 부피를 비교합니다. 보통 Fit3D, DXA, MRI 같은 체스캔이 필요합니다. 다리보다 몸통 부피 비율이 높으면 당뇨 전단계, 당뇨, 고중성지방, 고혈압, 대사증후군 등의 가능성이 커집니다.',
    nl:
      'De romp-beenvolumeverhouding vergelijkt het volume van de romp met dat van de benen. Dit vereist meestal een bodyscan (Fit3D, DXA of MRI). Een hoog aandeel volume in de romp t.o.v. de benen hangt samen met prediabetes, diabetes, hoge triglyceriden, hoge bloeddruk en metabole syndromen.',
    fi:
      'Vartalon ja jalkojen tilavuussuhde vertaa vartalon tilavuutta jalkoihin. Se vaatii yleensä kehon skannauksen (Fit3D, DXA tai MRI). Suuri tilavuusosuus vartalossa jalkoihin nähden liittyy esidiabetekseen, diabetekseen, korkeisiin triglyserideihin, verenpaineeseen ja metabolisiin oireyhtymiin.',
    ru:
      'Отношение объёма туловища к ногам сравнивает объём торса и ног. Обычно нужен скан тела (Fit3D, DXA или МРТ). Высокая доля объёма в торсе относительно ног связана с предиабетом, диабетом, высоким уровнем триглицеридов, давлением и метаболическим синдромом.',
    sv:
      'Volymförhållandet bål–ben jämför bålens volym med benens. Det kräver vanligtvis en kroppsskanning (Fit3D, DXA eller MRI). En hög andel volym i bålen jämfört med benen kopplas till prediabetes, diabetes, höga triglycerider, högt blodtryck och metabola syndrom.',
    ja:
      '体幹対脚体積比は体幹と脚の体積を比べます。通常は Fit3D、DXA、MRI などのスキャンが必要です。脚に対して体幹の体積割合が高いと、前糖尿病、糖尿病、高中性脂肪、高血圧、メタボリックシンドロームなどの可能性が高まります。',
    tr:
      'Gövde-bacak hacim oranı gövde hacmini bacaklarla karşılaştırır. Genelde vücut taraması (Fit3D, DXA veya MRI) gerekir. Bacaklara göre gövdede yüksek hacim oranı prediyabet, diyabet, yüksek trigliserit, yüksek tansiyon ve metabolik sendrom riskini artırır.',
    cs:
      'Poměr objemu trupu k nohám srovnává objem trupu s objemem nohou. Obvykle je nutný tělesný sken (Fit3D, DXA nebo MRI). Vysoký podíl objemu v trupu vůči nohám zvyšuje pravděpodobnost prediabetu, diabetu, vysokých triglyceridů, tlaku a metabolických syndromů.',
    el:
      'Η αναλογία όγκου κορμού-ποδιών συγκρίνει τον όγκο του κορμού με των ποδιών. Συνήθως χρειάζεται σάρωση σώματος (Fit3D, DXA ή MRI). Υψηλό ποσοστό όγκου στον κορμό έναντι των ποδιών αυξάνει την πιθανότητα προδιαβήτη, διαβήτη, υψηλών τριγλυκεριδίων, πίεσης και μεταβολικών συνδρόμων.',
    hr:
      'Omjer volumena trupa i nogu uspoređuje volumen trupa s volumenom nogu. Obično treba tjelesni sken (Fit3D, DXA ili MRI). Visok udio volumena u trupu u odnosu na noge povećava vjerojatnost predijabetesa, dijabetesa, visokih triglicerida, tlaka i metaboličkih sindroma.',
  },
  [visceralBelly]: {
    fr:
      'Le poids au milieu du corps est fortement lié à la graisse viscérale, autour des organes. Un gros ventre et des jambes plus fines suggèrent que le poids est centré sur le milieu et donc viscéral.',
    de:
      'Gewicht in der Körpermitte korreliert stark mit viszeralem Fett um die Organe. Ein großer Bauch und schmalere Beine deuten darauf hin, dass das Gewicht in der Mitte sitzt und viszeral ist.',
    es:
      'El peso en la zona media se correlaciona mucho con la grasa visceral alrededor de los órganos. Un abdomen grande y piernas más pequeñas sugieren que el peso está centrado ahí y es visceral.',
    pt:
      'O peso na zona média correlaciona-se fortemente com gordura visceral em volta dos órgãos. Barriga grande e pernas mais finas sugerem que o peso está no meio e é visceral.',
    zh_CN:
      '中段体重与包裹器官的内脏脂肪高度相关。大肚子、细腿通常说明重量集中在中段，因此是内脏脂肪。',
    zh_TW:
      '中段體重與包覆器官的內臟脂肪高度相關。大肚子、細腿通常表示重量集中在中段，因此是內臟脂肪。',
    it:
      'Il peso nella zona centrale è altamente correlato al grasso viscerale intorno agli organi. Una pancia grande e gambe più piccole suggeriscono che il peso è centrato lì e quindi viscerale.',
    ko:
      '허리 주변 체중은 장기 주위 내장 지방과 강하게 관련됩니다. 배가 크고 다리가 가늘면 체중이 중간에 몰린 내장 지방일 가능성이 큽니다.',
    nl:
      'Gewicht in het middensegment hangt sterk samen met visceraal vet rond organen. Een grote buik en smallere benen wijzen erop dat het gewicht daar zit en dus visceraal is.',
    fi:
      'Keskivartalon paino liittyy vahvasti elinten ympärillä olevaan viskeraaliseen rasvaan. Iso vatsa ja ohuemmat jalat viittaavat siihen, että paino on keskellä ja rasva viskeraalista.',
    ru:
      'Вес в средней части сильно связан с висцеральным жиром вокруг органов. Большой живот и более тонкие ноги говорят о том, что вес сосредоточен в середине и жир висцеральный.',
    sv:
      'Vikt i midsektionen korrelerar starkt med visceralt fett runt organen. En stor mage och smalare ben tyder på att vikten sitter där och är visceralt fett.',
    ja:
      '体幹部の体重は内臓の周りの内臓脂肪と強く関連します。お腹が大きく脚が細い場合、体重が中央に集中した内臓脂肪と考えられます。',
    tr:
      'Orta bölgedeki kilo, organların çevresindeki viseral yağla güçlü ilişkilidir. Büyük karın ve daha ince bacaklar, kilonun ortada ve viseral olduğunu düşündürür.',
    cs:
      'Hmotnost ve střední části silně souvisí s viscerálním tukem kolem orgánů. Velké břicho a tenčí nohy naznačují, že hmotnost je uprostřed a tuk je viscerální.',
    el:
      'Το βάρος στο μέσο του σώματος σχετίζεται έντονα με σπλαχνικό λίπος γύρω από όργανα. Μεγάλη κοιλιά και λεπτότερα πόδια υποδηλώνουν ότι το βάρος είναι κεντρικό και άρα σπλαχνικό.',
    hr:
      'Težina u sredini tijela jako je povezana s visceralnom masti oko organa. Veliki trbuh i tanje noge upućuju da je težina u sredini i da je mast visceralna.',
  },
  [tlrImprove]: {
    fr:
      'Cette formule dépend du volume, pas du poids. Pour améliorer le score, réduisez le volume du milieu du corps et augmentez celui des jambes.',
    de:
      'Diese Formel hängt vom Volumen ab, nicht vom Gewicht. Um den Wert zu verbessern, verringern Sie das Volumen der Körpermitte und erhöhen Sie das der Beine.',
    es:
      'Esta fórmula depende del volumen, no del peso. La forma simple de mejorar es reducir el volumen de la zona media y aumentar el de las piernas.',
    pt:
      'Esta fórmula depende do volume, não do peso. A forma simples de melhorar é diminuir o volume da zona média e aumentar o das pernas.',
    zh_CN:
      '该公式取决于体积而非体重。改善该分数的简单方法是减小中段体积并增加腿部体积。',
    zh_TW:
      '此公式取決於體積而非體重。改善該分數的簡單方法是縮小中段體積並增加腿部體積。',
    it:
      'Questa formula dipende dal volume, non dal peso. Per migliorare il punteggio, riduci il volume della zona centrale e aumenta quello delle gambe.',
    ko:
      '이 공식은 체중이 아니라 부피에 따라 달라집니다. 점수를 개선하는 단순한 방법은 허리 부피를 줄이고 다리 부피를 늘리는 것입니다.',
    nl:
      'Deze formule hangt van volume af, niet van gewicht. Verbeter het door het middensegment kleiner en de benen groter in volume te maken.',
    fi:
      'Kaava perustuu tilavuuteen, ei painoon. Pistemäärää parannetaan pienentämällä keskivartalon tilavuutta ja kasvattamalla jalkojen tilavuutta.',
    ru:
      'Формула зависит от объёма, а не от веса. Чтобы улучшить показатель, уменьшите объём середины тела и увеличьте объём ног.',
    sv:
      'Formeln beror på volym, inte vikt. Förbättra värdet genom att minska volymen i midjan och öka volymen i benen.',
    ja:
      'この式は体重ではなく体積に依存します。スコアを改善するには体幹の体積を減らし、脚の体積を増やします。',
    tr:
      'Bu formül kiloya değil hacme bağlıdır. Skoru iyileştirmenin basit yolu bel bölgesinin hacmini azaltıp bacak hacmini artırmaktır.',
    cs:
      'Tento vzorec závisí na objemu, ne na hmotnosti. Skóre zlepšíte zmenšením objemu střední části a zvětšením objemu nohou.',
    el:
      'Ο τύπος εξαρτάται από όγκο, όχι βάρος. Ο απλός τρόπος βελτίωσης είναι μείωση όγκου στη μέση και αύξηση όγκου στα πόδια.',
    hr:
      'Ova formula ovisi o volumenu, ne o težini. Jednostavan način poboljšanja je smanjiti volumen sredine tijela i povećati volumen nogu.',
  },
  [hiitAndOr]: {
    fr:
      'Cela passe par nutrition et exercice avec du HIIT. Consultez coach, nutritionniste, entraîneurs et/ou médecins pour un plan',
    de:
      'Das gelingt durch Ernährung und Training inklusive HIIT. Sprechen Sie mit Trainer, Ernährungsberater, Coaches und/oder Ärzten über einen Plan',
    es:
      'Se logra con nutrición y ejercicio que incluya HIIT. Consulta con entrenador, nutricionista, coaches y/o médicos para un plan',
    pt:
      'Faz-se com nutrição e exercício que inclua HIIT. Consulte treinador, nutricionista, coaches e/ou médicos para um plano',
    zh_CN:
      '可通过营养和包含高强度间歇训练的运动实现。请与教练、营养师和/或医生制定计划',
    zh_TW:
      '可透過營養與包含高強度間歇訓練的運動實現。請與教練、營養師和／或醫師制定計畫',
    it:
      'Si ottiene con alimentazione ed esercizio che include HIIT. Consulta trainer, nutrizionista, coach e/o medici per un piano',
    ko:
      '영양과 HIIT가 포함된 운동으로 가능합니다. 트레이너, 영양사, 코치 및/또는 의사와 계획을 세우세요',
    nl:
      'Dit kan met voeding en training inclusief HIIT. Overleg met trainer, voedingsdeskundige, coaches en/of artsen voor een plan',
    fi:
      'Tämä onnistuu ravinnolla ja HIIT-harjoittelulla. Laadi suunnitelma valmentajan, ravitsemusterapeutin, coachien ja/tai lääkäreiden kanssa',
    ru:
      'Это достигается питанием и нагрузками с HIIT. Составьте план с тренером, нутрициологом, коучами и/или врачами',
    sv:
      'Det görs med kost och träning inklusive HIIT. Rådgör med tränare, nutritionist, coacher och/eller läkare för en plan',
    ja:
      '栄養と HIIT を含む運動で実現できます。トレーナー、栄養士、コーチ、医師と計画を立ててください',
    tr:
      'Beslenme ve HIIT içeren egzersizle yapılabilir. Plan için antrenör, diyetisyen, koçlar ve/veya doktorlarla görüşün',
    cs:
      'Lze toho dosáhnout stravou a cvičením včetně HIIT. Plán sestavte s trenérem, výživovým poradcem, kouči a/nebo lékaři',
    el:
      'Γίνεται με διατροφή και άσκηση που περιλαμβάνει HIIT. Συμβουλευτείτε προπονητή, διατροφολόγο, coaches και/ή γιατρούς για πλάνο',
    hr:
      'To se postiže prehranom i vježbanjem koje uključuje HIIT. Dogovorite plan s trenerom, nutricionistom, coachovima i/ili liječnicima',
  },
  [bfpResearch]: {
    fr:
      'Grâce à des partenariats de recherche, Fit3D a scanné des milliers de personnes en parallèle Fit3D et DXA, puis créé des algorithmes à partir de centaines de mesures pour estimer le pourcentage de graisse.',
    de:
      'In Forschungskooperationen hat Fit3D Tausende Personen parallel mit Fit3D und DXA gescannt und Algorithmen aus Hunderten Messwerten entwickelt, um den Körperfettanteil zu berechnen.',
    es:
      'Con alianzas de investigación, Fit3D ha escaneado a miles de personas con Fit3D y DXA en paralelo y creado algoritmos con cientos de medidas para calcular el porcentaje de grasa.',
    pt:
      'Com parcerias de investigação, a Fit3D analisou milhares de pessoas com Fit3D e DXA em paralelo e criou algoritmos com centenas de medidas para calcular o percentual de gordura.',
    zh_CN:
      '通过研究合作，Fit3D 用 Fit3D 与 DXA 对照扫描了数千人，并利用扫描自动提取的数百项测量计算体脂率。',
    zh_TW:
      '透過研究合作，Fit3D 以 Fit3D 與 DXA 對照掃描了數千人，並利用掃描自動擷取的數百項測量計算體脂率。',
    it:
      'Grazie a partnership di ricerca, Fit3D ha scansionato migliaia di persone con Fit3D e DXA in parallelo e creato algoritmi da centinaia di misure per calcolare la percentuale di grasso.',
    ko:
      '연구 파트너십을 통해 Fit3D는 수천 명을 Fit3D와 DXA로 나란히 스캔하고, 스캔에서 자동 추출한 수백 개 측정값으로 체지방률을 계산하는 알고리즘을 만들었습니다.',
    nl:
      'Via onderzoekspartners heeft Fit3D duizenden mensen naast elkaar met Fit3D en DXA gescand en algoritmen gemaakt die honderden metingen gebruiken om het vetpercentage te berekenen.',
    fi:
      'Tutkimuskumppanuuksien avulla Fit3D on skannannut tuhansia ihmisiä rinnakkain Fit3D:llä ja DXA:lla ja luonut algoritmeja sadoista mittauksista rasvaprosentin laskemiseksi.',
    ru:
      'В партнёрстве с институтами Fit3D просканировала тысячи людей параллельно Fit3D и DXA и создала алгоритмы по сотням измерений для расчёта процента жира.',
    sv:
      'Genom forskningssamarbeten har Fit3D skannat tusentals personer med Fit3D och DXA sida vid sida och skapat algoritmer från hundratals mått för att beräkna kroppsfettprocent.',
    ja:
      '研究提携により Fit3D は数千人を Fit3D と DXA で同時スキャンし、スキャンから自動抽出した数百の測定値で体脂肪率を算出するアルゴリズムを作りました。',
    tr:
      'Araştırma ortaklıklarıyla Fit3D, binlerce kişiyi Fit3D ve DXA ile yan yana taradı ve yüzlerce ölçüden vücut yağ yüzdesi hesaplayan algoritmalar oluşturdu.',
    cs:
      'Ve výzkumných partnerstvích Fit3D naskenovala tisíce lidí souběžně Fit3D a DXA a vytvořila algoritmy ze stovek měření pro výpočet procenta tuku.',
    el:
      'Με ερευνητικές συνεργασίες η Fit3D σάρωσε χιλιάδες άτομα παράλληλα με Fit3D και DXA και δημιούργησε αλγορίθμους από εκατοντάδες μετρήσεις για το ποσοστό λίπους.',
    hr:
      'Kroz istraživačka partnerstva Fit3D je skenirao tisuće ljudi usporedno Fit3D-om i DXA-om te stvorio algoritme iz stotina mjera za izračun postotka masti.',
  },
  [bfpGlossary]: {
    fr:
      'Le pourcentage de graisse corporelle est la masse grasse totale divisée par la masse corporelle totale. La graisse est essentielle à la vie et à la reproduction ; trop de graisse nuit toutefois à la santé ou aux hormones. C’est aussi un indicateur de problèmes plus graves. Le',
    de:
      'Der Körperfettanteil ist die gesamte Fettmasse geteilt durch die Gesamtkörpermasse. Fett ist lebensnotwendig; zu viel kann Gesundheit oder Hormone beeinträchtigen. Er ist auch ein Hinweis auf ernstere Probleme. Das',
    es:
      'El porcentaje de grasa corporal es la masa grasa total dividida por la masa corporal total. La grasa es esencial para la vida y la reproducción; demasiada puede afectar la salud o las hormonas. También indica problemas más graves. El',
    pt:
      'O percentual de gordura é a massa gorda total dividida pela massa corporal total. A gordura é essencial à vida e à reprodução; o excesso pode afetar a saúde ou as hormonas. Também indica problemas mais graves. O',
    zh_CN:
      '体脂百分比等于脂肪总量除以总体重。脂肪对生命和生殖必需，但过多会影响健康或激素，也可能提示更严重问题。',
    zh_TW:
      '體脂百分比等於脂肪總量除以總體重。脂肪對生命與生殖必需，但過多會影響健康或荷爾蒙，也可能提示更嚴重問題。',
    it:
      'La percentuale di grasso corporeo è la massa grassa totale divisa per la massa corporea totale. Il grasso è essenziale per la vita e la riproduzione; troppa quantità può influire su salute o ormoni. È anche un indicatore di problemi più gravi. Il',
    ko:
      '체지방률은 총 지방량을 총 체중으로 나눈 값입니다. 지방은 생명과 생식에 필수지만 너무 많으면 건강이나 호르몬에 해롭고, 더 심각한 문제의 신호일 수 있습니다.',
    nl:
      'Het lichaamsvetpercentage is de totale vetmassa gedeeld door de totale lichaamsmassa. Vet is essentieel voor leven en voortplanting; te veel kan gezondheid of hormonen schaden. Het is ook een signaal voor ernstiger problemen. Het',
    fi:
      'Rasvaprosentti on rasvamassa jaettuna kokonaispainolla. Rasva on elintärkeää; liika rasva voi heikentää terveyttä tai hormoneja. Se myös viittaa vakavampiin ongelmiin.',
    ru:
      'Процент жира — жировая масса, делённая на массу тела. Жир необходим для жизни и репродукции; избыток вредит здоровью или гормонам и может указывать на более серьёзные проблемы.',
    sv:
      'Kroppsfettprocenten är fettmassan dividerad med den totala kroppsmassan. Fett är nödvändigt för liv och reproduktion; för mycket kan påverka hälsa eller hormoner och signalera allvarligare problem.',
    ja:
      '体脂肪率は脂肪量を体重で割った値です。脂肪は生命と生殖に不可欠ですが、多すぎると健康やホルモンに影響し、より深刻な問題の指標にもなります。',
    tr:
      'Vücut yağ yüzdesi toplam yağın toplam vücut kütlesine bölünmesidir. Yağ yaşam ve üreme için gereklidir; fazlası sağlık veya hormonları etkileyebilir ve daha ciddi sorunlara işaret edebilir.',
    cs:
      'Procento tuku je tuková hmota dělená celkovou hmotností. Tuk je nezbytný pro život a reprodukci; nadbytek může poškodit zdraví nebo hormony a signalizovat vážnější problémy.',
    el:
      'Το ποσοστό λίπους είναι η λιπώδης μάζα διά τη συνολική μάζα. Το λίπος είναι απαραίτητο για ζωή και αναπαραγωγή· η υπερβολή βλάπτει υγεία ή ορμόνες και δείχνει σοβαρότερα προβλήματα.',
    hr:
      'Postotak masti je masna masa podijeljena s ukupnom masom. Mast je nužna za život i reprodukciju; previše može narušiti zdravlje ili hormone i ukazati na ozbiljnije probleme.',
  },
  [essentialFatRemainder]: {
    fr:
      '(graisse nécessaire aux fonctions vitales) est en général de 10-13 % chez les femmes et 2-5 % chez les hommes (référence NASM).',
    de:
      '(Fett, das für Lebensfunktionen nötig ist) liegt in der Regel bei 10–13 % für Frauen und 2–5 % für Männer (laut NASM).',
    es:
      '(grasa necesaria para las funciones vitales) suele ser 10-13 % en mujeres y 2-5 % en hombres (referencia NASM).',
    pt:
      '(gordura necessária às funções vitais) é geralmente 10-13 % nas mulheres e 2-5 % nos homens (referência NASM).',
    zh_CN:
      '（维持生命所需的脂肪）女性一般为 10-13%，男性为 2-5%（NASM 参考）。',
    zh_TW:
      '（維持生命所需的脂肪）女性一般為 10-13%，男性為 2-5%（NASM 參考）。',
    it:
      '(grasso necessario alle funzioni vitali) è in genere 10-13% per le donne e 2-5% per gli uomini (riferimento NASM).',
    ko:
      '(생명 유지에 필요한 지방)은 일반적으로 여성 10-13%, 남성 2-5%입니다(NASM 기준).',
    nl:
      '(vet dat nodig is voor levensfuncties) is meestal 10-13% bij vrouwen en 2-5% bij mannen (NASM).',
    fi:
      '(elintoimintoihin tarvittava rasva) on yleensä 10–13 % naisilla ja 2–5 % miehillä (NASM).',
    ru:
      '(жир, нужный для жизненных функций) обычно составляет 10–13% у женщин и 2–5% у мужчин (NASM).',
    sv:
      '(fett som krävs för livsfunktioner) är vanligtvis 10–13 % för kvinnor och 2–5 % för män (NASM).',
    ja:
      '（生命維持に必要な脂肪）は一般に女性 10〜13%、男性 2〜5% です（NASM 参照）。',
    tr:
      '(yaşam işlevleri için gereken yağ) genellikle kadınlarda %10-13, erkeklerde %2-5’tir (NASM).',
    cs:
      '(tuk nutný k životním funkcím) je obvykle 10–13 % u žen a 2–5 % u mužů (NASM).',
    el:
      '(λίπος απαραίτητο για ζωτικές λειτουργίες) είναι συνήθως 10-13% στις γυναίκες και 2-5% στους άνδρες (NASM).',
    hr:
      '(mast potrebna za životne funkcije) općenito je 10–13 % kod žena i 2–5 % kod muškaraca (NASM).',
  },
  [decreaseBfp]: {
    fr:
      'Vous pouvez réduire le pourcentage de graisse par une alimentation équilibrée et de l’exercice, dont HIIT et cardio. Consultez coach, nutritionniste, entraîneurs et/ou médecins pour un plan.',
    de:
      'Sie können den Körperfettanteil durch ausgewogene Ernährung und Training inkl. HIIT und Cardio senken. Sprechen Sie mit Trainer, Ernährungsberater, Coaches und/oder Ärzten über einen Plan.',
    es:
      'Puedes bajar el porcentaje de grasa con nutrición y ejercicio que incluya HIIT y cardio. Consulta con entrenador, nutricionista, coaches y/o médicos para un plan.',
    pt:
      'Pode reduzir o percentual de gordura com nutrição e exercício que inclua HIIT e cardio. Consulte treinador, nutricionista, coaches e/ou médicos para um plano.',
    zh_CN:
      '可通过均衡营养以及包含高强度间歇和有氧的运动降低体脂率。请与教练、营养师和/或医生制定计划。',
    zh_TW:
      '可透過均衡營養以及包含高強度間歇與有氧的運動降低體脂率。請與教練、營養師和／或醫師制定計畫。',
    it:
      'Puoi ridurre la percentuale di grasso con alimentazione ed esercizio che includa HIIT e cardio. Consulta trainer, nutrizionista, coach e/o medici per un piano.',
    ko:
      '균형 잡힌 영양과 HIIT·유산소가 포함된 운동으로 체지방률을 낮출 수 있습니다. 트레이너, 영양사, 코치 및/또는 의사와 계획을 세우세요.',
    nl:
      'U kunt het vetpercentage verlagen met voeding en training inclusief HIIT en cardio. Overleg met trainer, voedingsdeskundige, coaches en/of artsen voor een plan.',
    fi:
      'Rasvaprosenttia voi laskea tasapainoisella ravinnolla sekä HIIT- ja kestävyysharjoittelulla. Laadi suunnitelma valmentajan, ravitsemusterapeutin, coachien ja/tai lääkäreiden kanssa.',
    ru:
      'Процент жира можно снизить питанием и нагрузками с HIIT и кардио. Составьте план с тренером, нутрициологом, коучами и/или врачами.',
    sv:
      'Du kan sänka kroppsfettprocenten med kost och träning inklusive HIIT och cardio. Rådgör med tränare, nutritionist, coacher och/eller läkare för en plan.',
    ja:
      'バランスの取れた栄養と HIIT・有酸素を含む運動で体脂肪率を下げられます。トレーナー、栄養士、コーチ、医師と計画を立ててください。',
    tr:
      'Dengeli beslenme ile HIIT ve kardiyo içeren egzersizle yağ yüzdesini düşürebilirsiniz. Plan için antrenör, diyetisyen, koçlar ve/veya doktorlarla görüşün.',
    cs:
      'Procento tuku můžete snížit stravou a cvičením včetně HIIT a kardia. Plán sestavte s trenérem, výživovým poradcem, kouči a/nebo lékaři.',
    el:
      'Μπορείτε να μειώσετε το ποσοστό λίπους με διατροφή και άσκηση που περιλαμβάνει HIIT και αερόβια. Συμβουλευτείτε προπονητή, διατροφολόγο, coaches και/ή γιατρούς.',
    hr:
      'Postotak masti možete smanjiti prehranom i vježbanjem koje uključuje HIIT i kardio. Dogovorite plan s trenerom, nutricionistom, coachovima i/ili liječnicima.',
  },
  [weightGlossary]: {
    fr:
      'Le poids est la masse d’une personne. C’est la mesure la plus simple, donc une métrique primaire ; pourtant la forme et la composition corporelles reflètent mieux la santé.',
    de:
      'Körpergewicht ist Masse bzw. Gewicht. Es ist leicht zu messen und daher eine Primärmetrik; Körperform und Zusammensetzung sind jedoch aussagekräftiger für die Gesundheit.',
    es:
      'El peso corporal es la masa de una persona. Es la métrica más fácil de medir y por eso es primaria; aun así, la forma y la composición describen mejor la salud.',
    pt:
      'O peso corporal é a massa de uma pessoa. É a métrica mais fácil de medir e por isso faz parte da avaliação primária; ainda assim, forma e composição descrevem melhor a saúde.',
    zh_CN:
      '体重是人的质量，测量最容易，因此属于主要评估指标；但体型和身体成分更能反映健康。',
    zh_TW:
      '體重是人的質量，測量最容易，因此屬於主要評估指標；但體型與身體組成更能反映健康。',
    it:
      'Il peso corporeo è la massa di una persona. È la metrica più facile da misurare e quindi primaria; tuttavia forma e composizione descrivono meglio la salute.',
    ko:
      '체중은 사람의 질량이며 측정이 가장 쉬워 기본 지표에 포함됩니다. 하지만 체형과 구성이 건강을 더 잘 나타냅니다.',
    nl:
      'Lichaamsgewicht is iemands massa. Het is het makkelijkst te meten en daarom een primaire metriek; lichaamsvorm en compositie zeggen echter meer over gezondheid.',
    fi:
      'Kehonpaino on henkilön massa. Se on helpoin mitata ja siksi perusmittari; kehon muoto ja koostumus kertovat terveydestä paremmin.',
    ru:
      'Вес — масса человека. Это самый простой показатель, поэтому он в первичной оценке; однако форма и состав тела лучше отражают здоровье.',
    sv:
      'Kroppsvikt är en persons massa. Det är det lättaste måttet och därför primärt; kroppsform och sammansättning säger dock mer om hälsan.',
    ja:
      '体重はその人の質量で、測定が最も簡単なため主要指標に含まれます。ただし体型と組成の方が健康をよりよく示します。',
    tr:
      'Vücut ağırlığı bir kişinin kütlesidir. Ölçümü en kolay olduğu için birincil metriktir; yine de vücut şekli ve kompozisyon sağlığı daha iyi yansıtır.',
    cs:
      'Tělesná hmotnost je hmotnost osoby. Je nejsnáze měřitelná, proto patří k primárním metrikám; tvar a složení těla však lépe vypovídají o zdraví.',
    el:
      'Το σωματικό βάρος είναι η μάζα ενός ατόμου. Είναι το ευκολότερο μέτρο, γι’ αυτό είναι βασικό· όμως σχήμα και σύσταση περιγράφουν καλύτερα την υγεία.',
    hr:
      'Tjelesna težina je masa osobe. Najlakše se mjeri pa je primarna metrika; ipak oblik i sastav tijela bolje opisuju zdravlje.',
  },
  [fatMassLead]: {
    fr:
      'La masse grasse est aussi appelée tissu adipeux. Ce tissu conjonctif lâche est principalement composé de',
    de:
      'Fettmasse wird auch als Fettgewebe bezeichnet. Dieses lockere Bindegewebe besteht vor allem aus',
    es:
      'La masa grasa también se conoce como tejido adiposo. Este tejido conectivo laxo está compuesto principalmente por',
    pt:
      'A massa gorda também é conhecida como tecido adiposo. Este tecido conjuntivo frouxo é composto principalmente por',
    zh_CN: '脂肪量也称脂肪组织。这种疏松结缔组织主要由',
    zh_TW: '脂肪量也稱脂肪組織。這種疏鬆結締組織主要由',
    it:
      'La massa grassa è anche nota come tessuto adiposo. Questo tessuto connettivo lasso è composto principalmente da',
    ko: '지방량은 지방 조직이라고도 합니다. 이 성긴 결합조직은 주로',
    nl:
      'Vetmassa wordt ook vetweefsel genoemd. Dit losse bindweefsel bestaat vooral uit',
    fi:
      'Rasvamassaa kutsutaan myös rasvakudokseksi. Tämä löyhä sidekudos koostuu pääosin',
    ru:
      'Жировая масса также называется жировой тканью. Эта рыхлая соединительная ткань состоит в основном из',
    sv:
      'Fettmassa kallas också fettvävnad. Denna lösa bindväv består främst av',
    ja: '脂肪量は脂肪組織とも呼ばれます。この疎性結合組織は主に',
    tr:
      'Yağ kütlesi yağ dokusu olarak da bilinir. Bu gevşek bağ dokusu esas olarak',
    cs:
      'Tuková hmota se také nazývá tuková tkáň. Toto řídké vazivo se skládá především z',
    el:
      'Η λιπώδης μάζα ονομάζεται και λιπώδης ιστός. Αυτός ο χαλαρός συνδετικός ιστός αποτελείται κυρίως από',
    hr:
      'Masna masa poznata je i kao masno tkivo. Ovo rahlo vezivno tkivo uglavnom čine',
  },
  [fatMassTrail]: {
    fr:
      '. Son rôle principal est de stocker l’énergie sous forme de lipides. Il amortit et isole aussi le corps.',
    de:
      '. Seine Hauptaufgabe ist die Energiespeicherung als Lipide. Es polstert und isoliert außerdem den Körper.',
    es:
      '. Su función principal es almacenar energía en forma de lípidos. También amortigua y aísla el cuerpo.',
    pt:
      '. O papel principal é armazenar energia sob a forma de lípidos. Também amortece e isola o corpo.',
    zh_CN: '组成。其主要作用是以脂质形式储存能量，并缓冲、隔热身体。',
    zh_TW: '組成。其主要作用是以脂質形式儲存能量，並緩衝、隔熱身體。',
    it:
      '. Il ruolo principale è immagazzinare energia sotto forma di lipidi. Ammortizza e isola anche il corpo.',
    ko:
      '로 이루어집니다. 주 역할은 지질 형태로 에너지를 저장하고 몸을 완충·단열하는 것입니다.',
    nl:
      '. De hoofdrol is energie opslaan als lipiden. Het dempt en isoleert ook het lichaam.',
    fi:
      '. Päätehtävä on varastoida energiaa lipideinä. Se myös pehmustaa ja eristää kehoa.',
    ru:
      '. Главная роль — запасать энергию в виде липидов. Ткань также амортизирует и изолирует тело.',
    sv:
      '. Huvudrollen är att lagra energi som lipider. Den dämpar och isolerar också kroppen.',
    ja:
      'で構成されます。主な役割は脂質としてエネルギーを蓄え、体を保護・断熱することです。',
    tr:
      ' oluşur. Ana görevi enerjiyi lipid olarak depolamaktır. Ayrıca vücudu yastıklar ve yalıtır.',
    cs:
      '. Hlavní úlohou je ukládat energii ve formě lipidů. Také tlumí a izoluje tělo.',
    el:
      '. Ο κύριος ρόλος είναι η αποθήκευση ενέργειας ως λιπίδια. Επίσης μαλακώνει και μονώνει το σώμα.',
    hr:
      '. Glavna uloga je pohrana energije u obliku lipida. Također amortizira i izolira tijelo.',
  },
  [threeFatTypes]: {
    fr: 'La graisse corporelle se compose principalement de trois types :',
    de: 'Körperfett besteht vor allem aus drei Fettarten:',
    es: 'La grasa corporal se compone principalmente de tres tipos de grasa:',
    pt:
      'A gordura corporal é composta principalmente por três tipos de gordura:',
    zh_CN: '体脂主要由三类脂肪组成：',
    zh_TW: '體脂主要由三類脂肪組成：',
    it: 'Il grasso corporeo è composto principalmente da tre tipi di grasso:',
    ko: '체지방은 주로 세 가지 지방으로 구성됩니다:',
    nl: 'Lichaamsvet bestaat vooral uit drie soorten vet:',
    fi: 'Kehon rasva koostuu pääosin kolmesta rasvatyypistä:',
    ru: 'Жир тела в основном состоит из трёх типов:',
    sv: 'Kroppsfett består främst av tre fetttyper:',
    ja: '体脂肪は主に 3 種類の脂肪で構成されます：',
    tr: 'Vücut yağı başlıca üç yağ türünden oluşur:',
    cs: 'Tělesný tuk se skládá především ze tří typů tuku:',
    el: 'Το σωματικό λίπος αποτελείται κυρίως από τρία είδη λίπους:',
    hr: 'Tjelesna mast uglavnom se sastoji od tri vrste masti:',
  },
  [twoComponent]: {
    fr:
      'Le modèle à 2 composantes (masse grasse et masse maigre) est largement utilisé. La masse grasse est le tissu adipeux ; la masse maigre, muscle, squelette et eau. Dans les modèles à 3 et 4 composantes, squelette et eau sont isolés.',
    de:
      'Das 2-Komponenten-Modell aus Fett- und Magermasse ist weit verbreitet. Fettmasse ist Fettgewebe; Magermasse Muskel, Skelett und Wasser. In 3- und 4-Komponenten-Modellen werden Skelett und Wasser getrennt.',
    es:
      'El modelo de 2 componentes (masa grasa y magra) se usa mucho. La masa grasa es tejido adiposo; la magra, músculo, esqueleto y agua. En modelos de 3 y 4 componentes, esqueleto y agua se miden por separado.',
    pt:
      'O modelo de 2 componentes (massa gorda e magra) é muito usado. A massa gorda é tecido adiposo; a magra, músculo, esqueleto e água. Nos modelos de 3 e 4 componentes, esqueleto e água isolam-se.',
    zh_CN:
      '由脂肪量和瘦体重组成的二分模型广泛用于身体成分。脂肪量是脂肪组织；瘦体重是肌肉、骨骼和水。三分、四分模型会单独测量骨骼和水。',
    zh_TW:
      '由脂肪量與瘦體重組成的二分模型廣泛用於身體組成。脂肪量是脂肪組織；瘦體重是肌肉、骨骼與水。三分、四分模型會單獨測量骨骼與水。',
    it:
      'Il modello a 2 componenti (massa grassa e magra) è ampiamente usato. La massa grassa è tessuto adiposo; la magra, muscolo, scheletro e acqua. Nei modelli a 3 e 4 componenti, scheletro e acqua sono isolati.',
    ko:
      '지방량과 제지방량으로 이루어진 2성분 모델이 널리 쓰입니다. 지방량은 지방 조직이고 제지방량은 근육, 골격, 수분입니다. 3·4성분 모델에서는 골격과 수분을 따로 측정합니다.',
    nl:
      'Het 2-componentenmodel van vet- en magere massa wordt veel gebruikt. Vetmassa is vetweefsel; magere massa spier, skelet en water. In 3- en 4-componentenmodellen worden skelet en water apart gemeten.',
    fi:
      'Kahden komponentin malli (rasva- ja rasvaton massa) on laajassa käytössä. Rasvamassa on rasvakudosta; rasvaton massa lihasta, luustoa ja vettä. 3- ja 4-komponenttisissa malleissa luusto ja vesi erotetaan.',
    ru:
      'Двухкомпонентная модель (жир и тощая масса) широко используется. Жировая масса — жировая ткань; тощая — мышцы, скелет и вода. В 3- и 4-компонентных моделях скелет и вода выделяются отдельно.',
    sv:
      '2-komponentmodellen med fett- och fettfri massa används ofta. Fettmassa är fettvävnad; fettfri massa muskel, skelett och vatten. I 3- och 4-komponentmodeller mäts skelett och vatten separat.',
    ja:
      '脂肪量と除脂肪量の 2 成分モデルが広く使われます。脂肪量は脂肪組織、除脂肪量は筋肉・骨格・水分です。3・4 成分モデルでは骨格と水分を分けます。',
    tr:
      'Yağ ve yağsız kütleden oluşan 2 bileşenli model yaygındır. Yağ kütlesi yağ dokusudur; yağsız kütle kas, iskelet ve sudur. 3 ve 4 bileşenli modellerde iskelet ve su ayrı ölçülür.',
    cs:
      'Dvousložkový model (tuková a hubená hmota) se široce používá. Tuková hmota je tuková tkáň; hubená hmota sval, kostra a voda. Ve 3- a 4složkových modelech se kostra a voda oddělují.',
    el:
      'Το μοντέλο 2 συστατικών (λιπώδης και άλιπη μάζα) χρησιμοποιείται ευρέως. Η λιπώδης μάζα είναι λιπώδης ιστός· η άλιπη μυς, σκελετός και νερό. Σε μοντέλα 3 και 4 συστατικών σκελετός και νερό απομονώνονται.',
    hr:
      'Dvodijelni model (masna i mršava masa) široko se koristi. Masna masa je masno tkivo; mršava masa mišić, kostur i voda. U 3- i 4-dijelnim modelima kostur i voda izdvajaju se zasebno.',
  },
  [increaseLean]: {
    fr:
      'Vous pouvez augmenter la masse maigre avec de la musculation et un programme nutritionnel. Si vous voulez seulement gagner du muscle sans perdre de graisse, le plan sera différent. Consultez coach, nutritionniste, entraîneurs et/ou médecins.',
    de:
      'Sie können Magermasse durch Krafttraining und ein Ernährungsprogramm steigern. Wer nur Magermasse aufbauen und nicht Fett verlieren will, braucht ein anderes Programm. Sprechen Sie mit Trainer, Ernährungsberater, Coaches und/oder Ärzten.',
    es:
      'Puedes aumentar la masa magra con entrenamiento de fuerza y un plan nutricional. Si solo buscas ganar magra sin perder grasa, el programa será distinto. Consulta con entrenador, nutricionista, coaches y/o médicos.',
    pt:
      'Pode aumentar a massa magra com treino de força e um programa nutricional. Se só quiser ganhar magra sem perder gordura, o programa será diferente. Consulte treinador, nutricionista, coaches e/ou médicos.',
    zh_CN:
      '可通过力量训练和营养方案增加瘦体重。若只增肌不减脂，计划会不同。请与教练、营养师和/或医生制定方案。',
    zh_TW:
      '可透過重量訓練與營養方案增加瘦體重。若只增肌不減脂，計畫會不同。請與教練、營養師和／或醫師制定方案。',
    it:
      'Puoi aumentare la massa magra con allenamento con i pesi e un programma nutrizionale. Se vuoi solo aumentare la magra senza perdere grasso, il programma sarà diverso. Consulta trainer, nutrizionista, coach e/o medici.',
    ko:
      '근력 운동과 영양 프로그램으로 제지방량을 늘릴 수 있습니다. 지방을 줄이지 않고 제지방만 늘리려면 프로그램이 달라집니다. 트레이너, 영양사, 코치 및/또는 의사와 상담하세요.',
    nl:
      'U kunt magere massa vergroten met krachttraining en voeding. Wie alleen magere massa wil opbouwen zonder vet te verliezen, heeft een ander programma nodig. Overleg met trainer, voedingsdeskundige, coaches en/of artsen.',
    fi:
      'Rasvatonta massaa voi kasvattaa voimaharjoittelulla ja ravinto-ohjelmalla. Jos haluat vain kasvattaa massaa etkä vähentää rasvaa, ohjelma on erilainen. Laadi suunnitelma valmentajan, ravitsemusterapeutin, coachien ja/tai lääkäreiden kanssa.',
    ru:
      'Тощую массу можно увеличить силовыми тренировками и питанием. Если нужно только набрать тощую массу без потери жира, программа будет другой. Составьте план с тренером, нутрициологом, коучами и/или врачами.',
    sv:
      'Du kan öka fettfri massa med styrketräning och ett nutritionsprogram. Vill du bara bygga massa utan att tappa fett blir programmet annorlunda. Rådgör med tränare, nutritionist, coacher och/eller läkare.',
    ja:
      'ウェイトトレーニングと栄養プログラムで除脂肪量を増やせます。減脂せず除脂肪だけ増やす場合、計画は異なります。トレーナー、栄養士、コーチ、医師に相談してください。',
    tr:
      'Kuvvet antrenmanı ve beslenme programıyla yağsız kütleyi artırabilirsiniz. Sadece yağsız kütle kazanıp yağ kaybetmek istemiyorsanız program farklı olur. Antrenör, diyetisyen, koçlar ve/veya doktorlarla görüşün.',
    cs:
      'Hubenou hmotu můžete zvýšit silovým tréninkem a výživovým programem. Pokud chcete jen nabírat hmotu bez ztráty tuku, program bude jiný. Sestavte plán s trenérem, výživovým poradcem, kouči a/nebo lékaři.',
    el:
      'Μπορείτε να αυξήσετε την άλιπη μάζα με βάρη και διατροφικό πρόγραμμα. Αν θέλετε μόνο άλιπη μάζα χωρίς απώλεια λίπους, το πρόγραμμα διαφέρει. Συμβουλευτείτε προπονητή, διατροφολόγο, coaches και/ή γιατρούς.',
    hr:
      'Mršavu masu možete povećati treningom snage i prehrambenim programom. Ako želite samo graditi masu bez gubitka masti, program će biti drukčiji. Dogovorite plan s trenerom, nutricionistom, coachovima i/ili liječnicima.',
  },
  [wcRisk]: {
    fr:
      'Le tour de taille (WC) prédit le risque indépendamment de l’IMC. Il est utile chez les personnes de corpulence normale ou en surpoids, car il est lié à la graisse viscérale et à la forme.',
    de:
      'Der Taillenumfang (WC) sagt das Risiko unabhängig vom BMI voraus. Er ist besonders nützlich bei normal- oder übergewichtigen Personen als Maß für viszerales Fett und Körperform.',
    es:
      'La circunferencia de cintura (WC) predice el riesgo independiente del IMC. Es útil en personas con peso normal o sobrepeso como medida asociada a grasa visceral y forma corporal.',
    pt:
      'A circunferência da cintura (WC) prevê o risco independente do IMC. É útil em pessoas com peso normal ou excesso de peso, associada a gordura visceral e forma corporal.',
    zh_CN:
      '腰围（WC）可独立于 BMI 预测风险，对 BMI 正常或超重者尤其有用，与内脏脂肪和体型相关。',
    zh_TW:
      '腰圍（WC）可獨立於 BMI 預測風險，對 BMI 正常或超重者尤其有用，與內臟脂肪和體型相關。',
    it:
      'La circonferenza vita (WC) predice il rischio indipendentemente dal BMI. È utile per chi è normopeso o sovrappeso, in quanto associata a grasso viscerale e forma corporea.',
    ko:
      '허리둘레(WC)는 BMI와 별개로 위험을 예측합니다. BMI가 정상이거나 과체중인 사람에게 내장 지방·체형과 관련된 측정으로 특히 유용합니다.',
    nl:
      'Tailleomtrek (WC) voorspelt risico onafhankelijk van BMI. Het is vooral nuttig bij normaal- of overgewicht als maat voor visceraal vet en lichaamsvorm.',
    fi:
      'Vyötärönympärys (WC) ennustaa riskiä BMI:stä riippumatta. Se on hyödyllinen normaali- tai ylipainoisilla, koska se liittyy viskeraaliseen rasvaan ja kehon muotoon.',
    ru:
      'Окружность талии (WC) прогнозирует риск независимо от ИМТ. Она полезна при нормальном или избыточном весе как мера висцерального жира и формы тела.',
    sv:
      'Midjemått (WC) förutsäger risk oberoende av BMI. Det är särskilt användbart vid normal- eller övervikt som mått kopplat till visceralt fett och kroppsform.',
    ja:
      '腹囲（WC）は BMI とは独立してリスクを予測します。BMI が普通または過体重の人で、内臓脂肪と体型に関連する指標として特に有用です。',
    tr:
      'Bel çevresi (WC), BMI’den bağımsız risk tahmini sağlar. Normal veya fazla kilolu kişilerde viseral yağ ve vücut şekliyle ilişkili bir ölçü olarak faydalıdır.',
    cs:
      'Obvod pasu (WC) predikuje riziko nezávisle na BMI. Je užitečný u osob s normální nebo nadváhou jako míra viscerálního tuku a tvaru těla.',
    el:
      'Η περίμετρος μέσης (WC) προβλέπει κίνδυνο ανεξάρτητα από ΔΜΣ. Είναι χρήσιμη σε φυσιολογικό ή υπέρβαρο βάρος ως μέτρο σπλαχνικού λίπους και σχήματος σώματος.',
    hr:
      'Opseg struka (WC) predviđa rizik neovisno o BMI-ju. Koristan je kod normalne ili prekomjerne težine kao mjera visceralnog masnog tkiva i oblika tijela.',
  },
  [wcHighRisk]: {
    fr:
      'Un risque élevé est associé aux hommes avec WC > 102 cm et aux femmes avec WC > 88 cm.',
    de:
      'Ein hohes Risiko besteht bei Männern mit WC > 102 cm und Frauen mit WC > 88 cm.',
    es:
      'Hay alto riesgo en hombres con WC > 102 cm y en mujeres con WC > 88 cm.',
    pt:
      'Há risco elevado em homens com WC > 102 cm e em mulheres com WC > 88 cm.',
    zh_CN: '男性 WC > 102 cm、女性 WC > 88 cm 与高风险相关。',
    zh_TW: '男性 WC > 102 cm、女性 WC > 88 cm 與高風險相關。',
    it:
      'Il rischio elevato è associato agli uomini con WC > 102 cm e alle donne con WC > 88 cm.',
    ko: '남성 WC > 102 cm, 여성 WC > 88 cm이면 고위험으로 봅니다.',
    nl:
      'Hoog risico geldt voor mannen met WC > 102 cm en vrouwen met WC > 88 cm.',
    fi:
      'Korkea riski liittyy miehiin, joilla WC > 102 cm, ja naisiin, joilla WC > 88 cm.',
    ru: 'Высокий риск связан с WC > 102 см у мужчин и WC > 88 см у женщин.',
    sv: 'Hög risk kopplas till män med WC > 102 cm och kvinnor med WC > 88 cm.',
    ja: '男性で WC > 102 cm、女性で WC > 88 cm は高リスクとされます。',
    tr:
      'Erkeklerde WC > 102 cm, kadınlarda WC > 88 cm yüksek riskle ilişkilidir.',
    cs: 'Vysoké riziko je u mužů s WC > 102 cm a u žen s WC > 88 cm.',
    el:
      'Υψηλός κίνδυνος σχετίζεται με άνδρες με WC > 102 cm και γυναίκες με WC > 88 cm.',
    hr:
      'Visok rizik povezuje se s muškarcima s WC > 102 cm i ženama s WC > 88 cm.',
  },
  [wcSmall]: {
    fr: 'Le WC est la circonférence mesurée au creux des reins.',
    de: 'WC ist der Umfang auf Höhe der Taille am unteren Rücken.',
    es:
      'La WC es la circunferencia tomada en la parte más estrecha de la espalda.',
    pt: 'A WC é a circunferência medida na parte mais estreita das costas.',
    zh_CN: 'WC 是在腰部最细处（后腰）测量的围度。',
    zh_TW: 'WC 是在腰部最細處（後腰）測量的圍度。',
    it:
      'La WC è la circonferenza misurata in corrispondenza della parte più stretta della schiena.',
    ko: 'WC는 등 가장 잘록한 곳(허리)에서 잰 둘레입니다.',
    nl: 'WC is de omtrek gemeten in de kleine van de rug.',
    fi: 'WC on ympärysmitta, joka otetaan selän kapeimmasta kohdasta.',
    ru: 'WC — обхват, измеренный в самом узком месте спины.',
    sv: 'WC är omkretsen mätt i svanken.',
    ja: 'WC は腰の最も細い位置（腰背部）で測る周囲です。',
    tr: 'WC, bel çukurundan alınan çevre ölçüsüdür.',
    cs: 'WC je obvod měřený v nejužším místě zad.',
    el: 'Το WC είναι η περίμετρος που λαμβάνεται στη μέση της πλάτης.',
    hr: 'WC je opseg mjeren na najužem dijelu leđa.',
  },
  [whrLimited]: {
    fr:
      'Ce rapport est une métrique de santé très limitée, mais simple pour estimer la graisse viscérale.',
    de:
      'Dieses Verhältnis ist als Gesundheitsmetrik sehr begrenzt, aber ein einfacher Versuch, viszerales Fett einzuschätzen.',
    es:
      'Este índice como métrica de salud es muy limitado, pero es una forma fácil de estimar la grasa visceral.',
    pt:
      'Esta relação como métrica de saúde é muito limitada, mas é uma forma fácil de estimar a gordura visceral.',
    zh_CN: '该比值作为健康指标非常有限，但是估计内脏脂肪的简便方法。',
    zh_TW: '此比值作為健康指標非常有限，但是估計內臟脂肪的簡便方法。',
    it:
      'Questo rapporto come metrica di salute è estremamente limitato, ma è un modo semplice per stimare il grasso viscerale.',
    ko:
      '이 비율은 건강 지표로서 매우 제한적이지만 내장 지방을 가늠하는 쉬운 방법입니다.',
    nl:
      'Deze verhouding is als gezondheidsmetriek zeer beperkt, maar een eenvoudige manier om visceraal vet in te schatten.',
    fi:
      'Suhde on terveysmittarina hyvin rajallinen, mutta helppo tapa arvioida viskeraalista rasvaa.',
    ru:
      'Это отношение как показатель здоровья крайне ограничено, но это простой способ оценить висцеральный жир.',
    sv:
      'Kvoten är som hälsomått mycket begränsad, men ett enkelt sätt att uppskatta visceralt fett.',
    ja:
      'この比は健康指標としては非常に限定的ですが、内臓脂肪をざっと見る簡便な方法です。',
    tr:
      'Bu oran sağlık metriği olarak oldukça sınırlıdır, ancak viseral yağı tahmin etmenin kolay bir yoludur.',
    cs:
      'Tento poměr je jako zdravotní metrika velmi omezený, ale je to snadný způsob, jak odhadnout viscerální tuk.',
    el:
      'Αυτός ο λόγος ως δείκτης υγείας είναι εξαιρετικά περιορισμένος, αλλά είναι εύκολος τρόπος εκτίμησης σπλαχνικού λίπους.',
    hr:
      'Ovaj omjer kao zdravstvena metrika iznimno je ograničen, ali je jednostavan način procjene visceralnog masnog tkiva.',
  },
  [whrImprove]: {
    fr:
      'On ne peut pas cibler la graisse localement, mais réduire la graisse globale avec vos coaches diminue souvent le tour de taille. Le WHR est limité mais largement utilisé.',
    de:
      'Fettmasse lässt sich nicht gezielt lokal reduzieren, aber mit Coaches die Gesamtmenge zu senken verringert meist den Umfang der Körpermitte. WHR ist begrenzt, aber weit verbreitet.',
    es:
      'No puedes reducir grasa de forma localizada, pero trabajar con tus coaches para bajarla en todo el cuerpo suele disminuir la circunferencia media. El WHR es limitado, pero se usa mucho.',
    pt:
      'Não se reduz gordura de forma localizada, mas trabalhar com os coaches para a reduzir no corpo costuma diminuir a circunferência média. O WHR é limitado, mas muito usado.',
    zh_CN:
      '无法局部减脂，但与教练一起减少全身脂肪通常会减小中段围度。WHR 范围很有限，但仍被广泛用作健康指标。',
    zh_TW:
      '無法局部減脂，但與教練一起減少全身脂肪通常會縮小中段圍度。WHR 範圍很有限，但仍被廣泛用作健康指標。',
    it:
      'Non si può ridurre il grasso in modo localizzato, ma lavorare con i coach per ridurlo in tutto il corpo generalmente diminuisce la circonferenza centrale. Il WHR è limitato ma molto usato.',
    ko:
      '특정 부위만 지방을 줄일 수는 없지만, 코치와 함께 전신 지방을 줄이면 보통 허리 둘레가 작아집니다. WHR은 범위가 매우 제한적이지만 건강 지표로 널리 쓰입니다.',
    nl:
      'U kunt vetmassa niet lokaal verminderen, maar met coaches het geheel verlagen verkleint meestal de middenomtrek. WHR is beperkt, maar wordt veel gebruikt.',
    fi:
      'Rasvaa ei voi polttaa paikallisesti, mutta coachien kanssa kokonaismäärän vähentäminen pienentää yleensä keskivartalon ympärystä. WHR on rajallinen mutta laajasti käytetty.',
    ru:
      'Жир нельзя убрать точечно, но работа с коучами по снижению общего количества обычно уменьшает обхват середины. WHR крайне ограничен, но широко используется.',
    sv:
      'Du kan inte punktförbränna fett, men att minska mängden med dina coacher minskar vanligtvis midjemåttet. WHR är begränsat men används mycket.',
    ja:
      '部分痩せはできませんが、コーチと全身の脂肪を減らすと中段の周囲は一般に小さくなります。WHR は範囲が狭い一方、健康指標として広く使われます。',
    tr:
      'Yağ kütlesini bölgesel olarak azaltamazsınız; koçlarla tüm vücutta azaltmak genellikle bel çevresini düşürür. WHR kapsam olarak sınırlıdır ama sağlık metriği olarak yaygındır.',
    cs:
      'Tuk nelze redukovat lokálně, ale práce s kouči na snížení celkového množství obvykle zmenší obvod střední části. WHR je velmi omezené, ale široce používané.',
    el:
      'Δεν μπορείτε να μειώσετε λίπος τοπικά, αλλά η μείωση σε όλο το σώμα με coaches μειώνει συνήθως την περίμετρο στη μέση. Το WHR είναι περιορισμένο αλλά ευρέως χρησιμοποιούμενο.',
    hr:
      'Masnoću ne možete smanjiti lokalno, ali rad s coachovima na smanjenju ukupne količine obično smanjuje opseg sredine. WHR je vrlo ograničen, ali se široko koristi.',
  },
  [whrConsult]: {
    fr:
      'Nous suggérons de consulter coach, nutritionniste, entraîneurs et/ou médecins avant de vous concentrer uniquement sur le WHR.',
    de:
      'Wir empfehlen, Trainer, Ernährungsberater, Coaches und/oder Ärzte zu konsultieren, bevor Sie sich nur auf den WHR konzentrieren.',
    es:
      'Sugerimos consultar con entrenador, nutricionista, coaches y/o médicos antes de centrarte solo en el WHR.',
    pt:
      'Sugerimos consultar treinador, nutricionista, coaches e/ou médicos antes de se focar só no WHR.',
    zh_CN: '建议在只关注 WHR 之前先与教练、营养师和/或医生制定计划。',
    zh_TW: '建議在只關注 WHR 之前先與教練、營養師和／或醫師制定計畫。',
    it:
      'Suggeriamo di consultare trainer, nutrizionista, coach e/o medici prima di concentrarti solo sul WHR.',
    ko:
      'WHR만 보기 전에 트레이너, 영양사, 코치 및/또는 의사와 계획을 세우길 권합니다.',
    nl:
      'We raden aan trainer, voedingsdeskundige, coaches en/of artsen te raadplegen voordat u zich alleen op WHR richt.',
    fi:
      'Suosittelemme konsultoimaan valmentajaa, ravitsemusterapeuttia, coacheja ja/tai lääkäreitä ennen kuin keskityt vain WHR:ään.',
    ru:
      'Рекомендуем согласовать план с тренером, нутрициологом, коучами и/или врачами, прежде чем фокусироваться только на WHR.',
    sv:
      'Vi föreslår att du rådgör med tränare, nutritionist, coacher och/eller läkare innan du enbart fokuserar på WHR.',
    ja:
      'WHR だけに注目する前に、トレーナー、栄養士、コーチ、医師と計画を立てることをおすすめします。',
    tr:
      'Yalnızca WHR’ye odaklanmadan önce antrenör, diyetisyen, koçlar ve/veya doktorlarla görüşmenizi öneririz.',
    cs:
      'Doporučujeme konzultovat trenéra, výživového poradce, kouče a/nebo lékaře, než se zaměříte pouze na WHR.',
    el:
      'Προτείνουμε να συμβουλευτείτε προπονητή, διατροφολόγο, coaches και/ή γιατρούς πριν εστιάσετε μόνο στο WHR.',
    hr:
      'Predlažemo da se konzultirate s trenerom, nutricionistom, coachovima i/ili liječnicima prije nego što se usredotočite samo na WHR.',
  },
  [bmrSummary]: {
    fr:
      'Le métabolisme de base (BMR) est l’énergie dépensée au repos, à température neutre et à jeun (souvent ~12 h). C’est l’énergie (calories) pour faire fonctionner le corps (respiration, circulation, température, croissance cellulaire, cerveau, muscles). Le BMR influe sur la dépense calorique et donc sur le maintien, la prise ou la perte de poids.',
    de:
      'Der Grundumsatz (BMR) ist der Energieverbrauch in Ruhe, bei neutraler Temperatur und im postabsorptiven Zustand (meist nach etwa zwölf Stunden Fasten). Es ist die Energie in Kalorien, die der Körper zum Funktionieren braucht. Der BMR beeinflusst, ob Gewicht gehalten, zu- oder abgenommen wird.',
    es:
      'La tasa metabólica basal (BMR) es la energía gastada en reposo, en ambiente neutro y en estado posabsortivo (unas doce horas de ayuno). Es la energía en calorías para mantener el cuerpo (respirar, circular, temperatura, células, cerebro, músculos). Influye en si se mantiene, gana o pierde peso.',
    pt:
      'A taxa metabólica basal (BMR) é a energia gasta em repouso, em ambiente neutro e em jejum (~12 h). É a energia em calorias para manter o corpo a funcionar. A BMR influencia se se mantém, ganha ou perde peso.',
    zh_CN:
      '基础代谢率（BMR）是中性温度、空腹（约 12 小时）休息时消耗的能量，即维持呼吸、循环、体温、细胞生长、神经和肌肉所需的热量。BMR 影响卡路里消耗以及体重维持、增加或下降。',
    zh_TW:
      '基礎代謝率（BMR）是中性溫度、空腹（約 12 小時）休息時消耗的能量，即維持呼吸、循環、體溫、細胞生長、神經與肌肉所需的熱量。BMR 影響卡路里消耗以及體重維持、增加或下降。',
    it:
      'Il metabolismo basale (BMR) è l’energia spesa a riposo, in ambiente termoneutro e a digiuno (circa dodici ore). È l’energia in calorie per far funzionare il corpo. Il BMR influisce sul mantenimento, l’aumento o la perdita di peso.',
    ko:
      '기초대사량(BMR)은 중성 온도·공복(약 12시간) 안정 상태에서 쓰는 에너지로, 호흡·순환·체온·세포 성장·뇌·근육을 유지하는 칼로리입니다. BMR은 칼로리 소모와 체중 유지·증가·감소에 영향을 줍니다.',
    nl:
      'Het basaal metabolisme (BMR) is de energie in rust, bij neutrale temperatuur en nuchter (vaak ~12 uur). Het is de energie in calorieën om het lichaam te laten functioneren. BMR beïnvloedt of u gewicht behoudt, aankomt of afvalt.',
    fi:
      'Perusaineenvaihdunta (BMR) on energia, joka kuluu levossa neutraalissa lämpötilassa ja paaston jälkeen (noin 12 h). Se on kaloreita kehon toimintoihin. BMR vaikuttaa siihen, säilyykö paino, nouseeko vai laskeeko se.',
    ru:
      'Базовый метаболизм (BMR) — энергия в покое при нейтральной температуре и натощак (обычно ~12 часов). Это калории для работы тела. BMR влияет на то, сохраняется, растёт или падает вес.',
    sv:
      'Basalmetabolism (BMR) är energin i vila, i neutral temperatur och efter fasta (~12 timmar). Det är kalorier för att hålla kroppen igång. BMR påverkar om vikten behålls, ökar eller minskar.',
    ja:
      '基礎代謝量（BMR）は中性温度・空腹（約 12 時間）の安静時エネルギーで、呼吸・循環・体温・細胞成長・脳神経・筋収縮に使うカロリーです。BMR は消費カロリーと体重の維持・増減に影響します。',
    tr:
      'Bazal metabolizma hızı (BMR), nötr sıcaklıkta ve tokluk sonrası (genelde ~12 saat açlık) dinlenirken harcanan enerjidir. Vücudun çalışması için gereken kaloridir. BMR, kilonun korunmasını, artmasını veya azalmasını etkiler.',
    cs:
      'Bazální metabolismus (BMR) je energie v klidu, v neutrální teplotě a nalačno (asi 12 hodin). Jsou to kalorie k udržení funkcí těla. BMR ovlivňuje, zda se hmotnost udržuje, stoupá, nebo klesá.',
    el:
      'Ο βασικός μεταβολικός ρυθμός (BMR) είναι η ενέργεια σε ηρεμία, σε ουδέτερη θερμοκρασία και νηστεία (~12 ώρες). Είναι οι θερμίδες για τη λειτουργία του σώματος. Το BMR επηρεάζει αν το βάρος διατηρείται, αυξάνεται ή μειώνεται.',
    hr:
      'Bazalni metabolizam (BMR) energija je u mirovanju, u neutralnoj temperaturi i natašte (oko 12 sati). To su kalorije za rad tijela. BMR utječe na to održava li se, raste ili pada težina.',
  },
  [bmrImprove]: {
    fr:
      'Augmentez le BMR avec du HIIT ou de la musculation, plus de protéines, plusieurs petits repas et une bonne hydratation. Plus il y a de muscle maigre, plus le BMR est élevé. Consultez coach, nutritionniste, entraîneurs et/ou médecins.',
    de:
      'Erhöhen Sie den BMR mit HIIT oder Krafttraining, mehr Protein, mehreren kleinen Mahlzeiten und ausreichender Flüssigkeit. Mehr Magermuskel bedeutet höheren BMR. Sprechen Sie mit Trainer, Ernährungsberater, Coaches und/oder Ärzten.',
    es:
      'Puedes subir la BMR con HIIT o pesas, más proteína, varias comidas pequeñas e hidratación. Cuanto más músculo magro, mayor BMR. Consulta con entrenador, nutricionista, coaches y/o médicos.',
    pt:
      'Pode aumentar a BMR com HIIT ou pesos, mais proteína, várias refeições pequenas e hidratação. Quanto mais músculo magro, maior a BMR. Consulte treinador, nutricionista, coaches e/ou médicos.',
    zh_CN:
      '可通过 HIIT 或力量训练、更多蛋白质、少量多餐和充足水分提高 BMR。瘦肌越多，BMR 越高。请与教练、营养师和/或医生制定计划。',
    zh_TW:
      '可透過 HIIT 或重量訓練、更多蛋白質、少量多餐與充足水分提高 BMR。瘦肌越多，BMR 越高。請與教練、營養師和／或醫師制定計畫。',
    it:
      'Puoi aumentare il BMR con HIIT o pesi, più proteine, più pasti piccoli e idratazione. Più muscolo magro hai, più alto è il BMR. Consulta trainer, nutrizionista, coach e/o medici.',
    ko:
      'HIIT나 근력 운동, 단백질 섭취, 소량 다회 식사, 수분 섭취로 BMR을 높일 수 있습니다. 제지방 근육이 많을수록 BMR이 높습니다. 트레이너, 영양사, 코치 및/또는 의사와 상담하세요.',
    nl:
      'Verhoog BMR met HIIT of krachttraining, meer eiwit, meerdere kleine maaltijden en hydratatie. Meer magere spier betekent hoger BMR. Overleg met trainer, voedingsdeskundige, coaches en/of artsen.',
    fi:
      'BMR:ää voi nostaa HIIT- tai voimaharjoittelulla, proteiinilla, useilla pienillä aterioilla ja nesteytyksellä. Mitä enemmän rasvatonta lihasta, sitä korkeampi BMR. Laadi suunnitelma valmentajan, ravitsemusterapeutin, coachien ja/tai lääkäreiden kanssa.',
    ru:
      'BMR можно повысить HIIT или силовыми, большим количеством белка, частыми небольшими приёмами пищи и гидратацией. Чем больше тощей мышцы, тем выше BMR. Составьте план с тренером, нутрициологом, коучами и/или врачами.',
    sv:
      'Höj BMR med HIIT eller styrketräning, mer protein, flera små måltider och vätska. Mer fettfri muskel ger högre BMR. Rådgör med tränare, nutritionist, coacher och/eller läkare.',
    ja:
      'HIIT や筋トレ、たんぱく質、少量多食、水分補給で BMR を上げられます。除脂肪筋が多いほど BMR は高くなります。トレーナー、栄養士、コーチ、医師に相談してください。',
    tr:
      'HIIT veya ağırlık, daha fazla protein, küçük öğünler ve hidrasyonla BMR’yi artırabilirsiniz. Ne kadar yağsız kas varsa BMR o kadar yüksektir. Antrenör, diyetisyen, koçlar ve/veya doktorlarla görüşün.',
    cs:
      'BMR můžete zvýšit HIIT nebo silovým tréninkem, více bílkovinami, menšími jídly a hydratací. Čím více hubené svaloviny, tím vyšší BMR. Sestavte plán s trenérem, výživovým poradcem, kouči a/nebo lékaři.',
    el:
      'Αυξήστε το BMR με HIIT ή βάρη, περισσότερη πρωτεΐνη, μικρά γεύματα και ενυδάτωση. Όσο περισσότερος άλιπος μυς, τόσο υψηλότερο το BMR. Συμβουλευτείτε προπονητή, διατροφολόγο, coaches και/ή γιατρούς.',
    hr:
      'BMR možete povećati HIIT-om ili dizanjem utega, više proteina, manjim obrocima i hidratacijom. Što više mršavog mišića, to je BMR viši. Dogovorite plan s trenerom, nutricionistom, coachovima i/ili liječnicima.',
  },
  [bpLead]: {
    fr: 'La pression artérielle est la',
    de: 'Der Blutdruck ist der',
    es: 'La presión arterial es la',
    pt: 'A pressão arterial é a',
    zh_CN: '血压是循环',
    zh_TW: '血壓是循環',
    it: 'La pressione sanguigna è la',
    ko: '혈압은 순환하는',
    nl: 'Bloeddruk is de',
    fi: 'Verenpaine on',
    ru: 'Артериальное давление — это',
    sv: 'Blodtryck är det',
    ja: '血圧は循環する',
    tr: 'Kan basıncı,',
    cs: 'Krevní tlak je',
    el: 'Η αρτηριακή πίεση είναι η',
    hr: 'Krvni tlak je',
  },
  [bpUpon]: {
    fr: 'exercée par le sang en circulation',
    de: 'durch zirkulierendes Blut ausgeübte Druck',
    es: 'ejercida por la sangre en circulación',
    pt: 'exercida pelo sangue em circulação',
    zh_CN: '血液对',
    zh_TW: '血液對',
    it: 'esercitata dal sangue in circolo',
    ko: '혈액이',
    nl: 'uitgeoefend door circulerend bloed',
    fi: 'kiertävän veren aiheuttama paine',
    ru: 'давление циркулирующей крови',
    sv: 'tryck som utövas av cirkulerande blod',
    ja: '血液が',
    tr: 'dolaşan kanın uyguladığı',
    cs: 'vyvolávaný cirkulující krví',
    el: 'που ασκείται από το κυκλοφορούν αίμα',
    hr: 'koji kružeća krv vrši',
  },
  [bpUponWalls]: {
    fr: 'sur les parois des',
    de: 'auf die Wände der',
    es: 'sobre las paredes de los',
    pt: 'sobre as paredes dos',
    zh_CN: '血管壁施加的压力。',
    zh_TW: '血管壁施加的壓力。',
    it: 'sulle pareti dei',
    ko: '혈관 벽에 가하는 압력입니다.',
    nl: 'op de wanden van',
    fi: 'suonten seinämiin',
    ru: 'на стенки',
    sv: 'på väggarna i',
    ja: '血管壁に及ぼす圧力です。',
    tr: 'duvarlarına uygulanan basınçtır',
    cs: 'na stěny',
    el: 'στα τοιχώματα των',
    hr: 'na stijenke',
  },
  [bpUsually]: {
    fr: '. On parle généralement de pression',
    de: '. „Blutdruck“ meint meist den',
    es: '. «Presión arterial» suele referirse a la presión',
    pt: '. «Pressão arterial» refere-se geralmente à pressão',
    zh_CN: '“血压”通常指',
    zh_TW: '「血壓」通常指',
    it: '. «Pressione sanguigna» di solito indica la pressione',
    ko: '. “혈압”은 보통',
    nl: '. „Bloeddruk” verwijst meestal naar de',
    fi: '. ”Verenpaine” tarkoittaa yleensä',
    ru: '. «Артериальное давление» обычно означает',
    sv: '. ”Blodtryck” avser vanligtvis det',
    ja: '「血圧」は通常、',
    tr: '. “Kan basıncı” genellikle',
    cs: '. „Krevní tlak“ obvykle označuje',
    el: '. Η «αρτηριακή πίεση» συνήθως αναφέρεται στην',
    hr: '. „Krvni tlak“ obično se odnosi na',
  },
  [bpInThe]: {
    fr: 'dans la',
    de: 'in der',
    es: 'en la',
    pt: 'na',
    zh_CN: '中的动脉压。',
    zh_TW: '中的動脈壓。',
    it: 'nella',
    ko: '의 동맥압을 가리킵니다.',
    nl: 'in de',
    fi: 'paine',
    ru: 'давление в',
    sv: 'trycket i',
    ja: 'における動脈圧です。',
    tr: 'içindeki',
    cs: 'tlak v',
    el: 'πίεση στην',
    hr: 'tlak u',
  },
  [bpVaries]: {
    fr:
      '. Elle varie selon l’environnement, l’activité et les maladies, et est régulée par les systèmes nerveux et endocrinien.',
    de:
      '. Er schwankt je nach Umgebung, Aktivität und Krankheit und wird von Nerven- und Hormonsystem geregelt.',
    es:
      '. Varía según el entorno, la actividad y las enfermedades, y la regulan los sistemas nervioso y endocrino.',
    pt:
      '. Varia com o ambiente, a atividade e as doenças, e é regulada pelos sistemas nervoso e endócrino.',
    zh_CN: '血压随环境、活动和疾病状态变化，并由神经和内分泌系统调节。',
    zh_TW: '血壓隨環境、活動與疾病狀態變化，並由神經與內分泌系統調節。',
    it:
      '. Varia in base ad ambiente, attività e malattie ed è regolata dai sistemi nervoso ed endocrino.',
    ko:
      '혈압은 환경, 활동, 질병 상태에 따라 달라지며 신경계와 내분비계가 조절합니다.',
    nl:
      '. Hij varieert met omgeving, activiteit en ziekte en wordt geregeld door zenuw- en endocrien stelsel.',
    fi:
      '. Se vaihtelee ympäristön, toiminnan ja sairauksien mukaan, ja hermosto sekä umpieritys säätelevät sitä.',
    ru:
      '. Оно меняется в зависимости от среды, активности и болезней и регулируется нервной и эндокринной системами.',
    sv:
      '. Det varierar med miljö, aktivitet och sjukdom och regleras av nerv- och endokrina system.',
    ja: '血圧は環境・活動・疾患によって変化し、神経と内分泌系が調節します。',
    tr:
      '. Çevre, aktivite ve hastalığa göre değişir; sinir ve endokrin sistemler düzenler.',
    cs:
      '. Kolísá podle prostředí, aktivity a nemocí a je řízen nervovým a endokrinním systémem.',
    el:
      '. Μεταβάλλεται ανάλογα με περιβάλλον, δραστηριότητα και νόσο και ρυθμίζεται από νευρικό και ενδοκρινικό σύστημα.',
    hr:
      '. Mijenja se ovisno o okolišu, aktivnosti i bolestima, a reguliraju ga živčani i endokrini sustav.',
  },
  [hrLead]: {
    fr:
      'La fréquence cardiaque est le rythme des battements mesuré en contractions par minute (bpm). Elle varie selon les besoins',
    de:
      'Die Herzfrequenz ist die Schlaggeschwindigkeit in Kontraktionen pro Minute (bpm). Sie schwankt je nach den körperlichen',
    es:
      'La frecuencia cardíaca es la velocidad del latido en contracciones por minuto (lpm). Puede variar según las necesidades',
    pt:
      'A frequência cardíaca é a velocidade do batimento em contrações por minuto (bpm). Pode variar segundo as necessidades',
    zh_CN: '心率是每分钟心脏收缩次数（bpm）。它会随身体的',
    zh_TW: '心率是每分鐘心臟收縮次數（bpm）。它會隨身體的',
    it:
      'La frequenza cardiaca è la velocità del battito in contrazioni al minuto (bpm). Può variare secondo le esigenze',
    ko: '심박수는 분당 심장 수축 횟수(bpm)입니다. 몸의',
    nl:
      'Hartslag is de snelheid van de hartslag in contracties per minuut (bpm). Hij kan variëren met de',
    fi:
      'Syke on sydämen supistusten määrä minuutissa (bpm). Se voi vaihdella kehon',
    ru:
      'Частота сердечных сокращений — скорость ударов в минуту (уд/мин). Она меняется в зависимости от',
    sv:
      'Hjärtfrekvens är hjärtslagens hastighet i kontraktioner per minut (bpm). Den kan variera med kroppens',
    ja: '心拍数は 1 分あたりの収縮回数（bpm）です。体の',
    tr: 'Kalp atış hızı, dakikadaki kasılma sayısıdır (bpm). Vücudun',
    cs:
      'Srdeční frekvence je rychlost tepu v kontrakcích za minutu (bpm). Může se měnit podle',
    el:
      'Ο καρδιακός ρυθμός είναι η ταχύτητα παλμών σε συσπάσεις ανά λεπτό (bpm). Μπορεί να μεταβάλλεται ανάλογα με τις',
    hr:
      'Otkucaji srca brzina su otkucaja mjerena kontrakcijama u minuti (bpm). Mogu varirati prema',
  },
  [hrNeeds]: {
    fr: 'du corps, notamment absorber l’oxygène et éliminer',
    de: 'Bedarf, einschließlich Sauerstoffaufnahme und Ausscheidung von',
    es: 'del cuerpo, incluida la necesidad de absorber oxígeno y excretar',
    pt: 'do corpo, incluindo absorver oxigénio e excretar',
    zh_CN: '需求而变化，包括吸收氧气和排出',
    zh_TW: '需求而變化，包括吸收氧氣與排出',
    it: 'del corpo, tra cui assorbire ossigeno ed eliminare',
    ko: '필요에 따라 달라지며 산소 흡수와',
    nl: 'lichaamsbehoefte, waaronder zuurstof opnemen en',
    fi: 'tarpeiden mukaan, kuten hapen otto ja',
    ru: 'потребностей тела, включая поглощение кислорода и выведение',
    sv: 'behov, inklusive att ta upp syre och utsöndra',
    ja: '必要に応じて変わり、酸素の取り込みと',
    tr: 'ihtiyaçlarına göre değişir; oksijen almak ve',
    cs: 'potřeb těla, včetně příjmu kyslíku a vylučování',
    el: 'ανάγκες του σώματος, όπως απορρόφηση οξυγόνου και αποβολή',
    hr: 'potrebama tijela, uključujući unos kisika i izlučivanje',
  },
  [hrNormal]: {
    fr: '. Au repos, le rythme adulte normal est de 60 à 100 bpm.',
    de: '. Die normale Ruhefrequenz Erwachsener liegt bei 60–100 bpm.',
    es: '. En reposo, el ritmo adulto normal es de 60-100 lpm.',
    pt: '. Em repouso, o ritmo adulto normal é 60-100 bpm.',
    zh_CN: '。成人安静心率一般为 60-100 次/分。',
    zh_TW: '。成人安靜心率一般為 60-100 次／分。',
    it: '. A riposo, il ritmo adulto normale è 60-100 bpm.',
    ko: ' 배출이 포함됩니다. 성인 안정 시 정상 심박수는 분당 60-100회입니다.',
    nl: '. De normale rusthartslag bij volwassenen is 60-100 bpm.',
    fi: '. Aikuisen normaali leposyke on 60–100 bpm.',
    ru: '. В покое норма для взрослых — 60–100 уд/мин.',
    sv: '. Vilopulsen för vuxna är normalt 60–100 bpm.',
    ja: 'の排出が必要です。成人の安静時心拍数は通常 60〜100 bpm です。',
    tr: ' atmak dahil. Yetişkinlerde normal istirahat hızı 60-100 bpm’dir.',
    cs: '. Klidová tepová frekvence dospělých je obvykle 60–100 bpm.',
    el: '. Ο φυσιολογικός ρυθμός ηρεμίας ενηλίκων είναι 60-100 bpm.',
    hr: '. Normalni ritam odraslih u mirovanju je 60–100 bpm.',
  },
  [adiposeFormula]: {
    fr: 'La masse du tissu adipeux dans le corps est donnée par :',
    de: 'Die Masse des Fettgewebes im Körper ergibt sich aus:',
    es: 'La masa del tejido adiposo en el cuerpo se obtiene con:',
    pt: 'A massa do tecido adiposo no corpo é dada por:',
    zh_CN: '体内脂肪组织的质量由下式给出：',
    zh_TW: '體內脂肪組織的質量由下式給出：',
    it: 'La massa del tessuto adiposo nel corpo è data da:',
    ko: '체내 지방 조직의 질량은 다음과 같습니다:',
    nl: 'De massa van het vetweefsel in het lichaam wordt gegeven door:',
    fi: 'Rasvakudoksen massa kehossa saadaan kaavalla:',
    ru: 'Масса жировой ткани в теле задаётся так:',
    sv: 'Massan av fettvävnaden i kroppen ges av:',
    ja: '体内の脂肪組織の質量は次式で与えられます：',
    tr: 'Vücuttaki yağ dokusu kütlesi şöyle verilir:',
    cs: 'Hmotnost tukové tkáně v těle je dána:',
    el: 'Η μάζα του λιπώδους ιστού στο σώμα δίνεται από:',
    hr: 'Masa masnog tkiva u tijelu dana je s:',
  },
  [eatLabel]: {
    fr: 'Tissu adipeux épicardique (EAT)',
    de: 'Epikardiales Fettgewebe (EAT)',
    es: 'Tejido adiposo epicárdico (EAT)',
    pt: 'Tecido adiposo epicárdico (EAT)',
    zh_CN: '心外膜脂肪组织 (EAT)',
    zh_TW: '心外膜脂肪組織 (EAT)',
    it: 'Tessuto adiposo epicardico (EAT)',
    ko: '심장외막 지방조직 (EAT)',
    nl: 'Epicardiaal vetweefsel (EAT)',
    fi: 'Epikardiaalinen rasvakudos (EAT)',
    ru: 'Эпикардиальная жировая ткань (EAT)',
    sv: 'Epikardiell fettvävnad (EAT)',
    ja: '心外膜脂肪組織 (EAT)',
    tr: 'Epikardiyal yağ dokusu (EAT)',
    cs: 'Epikardiální tuková tkáň (EAT)',
    el: 'Επικαρδιακός λιπώδης ιστός (EAT)',
    hr: 'Epikardijalno masno tkivo (EAT)',
  },
  [bmrShort]: {
    fr: 'La quantité d’énergie que votre corps dépense au repos.',
    de: 'Die Energiemenge, die Ihr Körper in Ruhe verbraucht.',
    es: 'La cantidad de energía que tu cuerpo quema en reposo.',
    pt: 'A quantidade de energia que o corpo gasta em repouso.',
    zh_CN: '身体在休息时消耗的能量。',
    zh_TW: '身體在休息時消耗的能量。',
    it: 'La quantità di energia che il corpo consuma a riposo.',
    ko: '몸이 안정 상태에서 쓰는 에너지의 양입니다.',
    nl: 'De hoeveelheid energie die uw lichaam in rust verbrandt.',
    fi: 'Energia, jonka kehosi kuluttaa levossa.',
    ru: 'Количество энергии, которое тело тратит в покое.',
    sv: 'Den energi din kropp förbränner i vila.',
    ja: '安静時に体が消費するエネルギー量です。',
    tr: 'Vücudunuzun dinlenirken yaktığı enerji miktarı.',
    cs: 'Množství energie, které tělo spaluje v klidu.',
    el: 'Η ενέργεια που καταναλώνει το σώμα σε ηρεμία.',
    hr: 'Količina energije koju tijelo troši u mirovanju.',
  },
  [whrRisk]: {
    fr:
      'Le WHR sert généralement à évaluer le risque d’obésité, de diabète, de maladie coronarienne et/ou d’hypertension. Il décrit la forme du milieu du corps.',
    de:
      'WHR wird allgemein genutzt, um ein erhöhtes Risiko für Adipositas, Diabetes, koronare Herzkrankheit und/oder Bluthochdruck einzuschätzen. Die Messung bewertet die Körperform in der Körpermitte.',
    es:
      'El WHR se usa generalmente para evaluar si hay alto riesgo de obesidad, diabetes, enfermedad coronaria y/o hipertensión. La medición evalúa la forma en la zona media.',
    pt:
      'O WHR avalia geralmente o risco elevado de obesidade, diabetes, doença coronária e/ou hipertensão. A medição avalia a forma na zona média do corpo.',
    zh_CN:
      'WHR 通常用于评估肥胖、糖尿病、冠心病和/或高血压的高风险。该测量评估中段体型。',
    zh_TW:
      'WHR 通常用於評估肥胖、糖尿病、冠心病和／或高血壓的高風險。該測量評估中段體型。',
    it:
      'Il WHR valuta in genere il rischio elevato di obesità, diabete, cardiopatia coronarica e/o ipertensione. La misura valuta la forma nella zona centrale del corpo.',
    ko:
      'WHR은 비만, 당뇨, 관상동맥질환 및/또는 고혈압의 고위험을 평가하는 데 쓰입니다. 이 측정은 몸 중간의 체형을 봅니다.',
    nl:
      'WHR wordt gebruikt om een hoog risico op obesitas, diabetes, coronaire hartziekte en/of hoge bloeddruk te beoordelen. De meting evalueert de lichaamsvorm in het middensegment.',
    fi:
      'WHR:llä arvioidaan yleensä lihavuuden, diabeteksen, sepelvaltimotaudin ja/tai verenpaineen riskiä. Mittaus kuvaa kehon keskiosan muotoa.',
    ru:
      'WHR обычно оценивает высокий риск ожирения, диабета, ИБС и/или гипертонии. Измерение описывает форму средней части тела.',
    sv:
      'WHR används vanligtvis för att bedöma hög risk för fetma, diabetes, kranskärlssjukdom och/eller högt blodtryck. Måttet utvärderar kroppsformen i midsektionen.',
    ja:
      'WHR は肥満、糖尿病、冠動脈疾患、高血圧などの高リスク評価に使われます。体幹中央の体型を評価します。',
    tr:
      'WHR genellikle obezite, diyabet, koroner kalp hastalığı ve/veya yüksek tansiyon riskini değerlendirmek için kullanılır. Ölçüm vücudun orta bölümünün şeklini değerlendirir.',
    cs:
      'WHR se obecně používá k hodnocení vysokého rizika obezity, diabetu, ischemické choroby srdeční a/nebo vysokého tlaku. Měření hodnotí tvar střední části těla.',
    el:
      'Το WHR χρησιμοποιείται γενικά για αξιολόγηση υψηλού κινδύνου παχυσαρκίας, διαβήτη, στεφανιαίας νόσου και/ή υπέρτασης. Η μέτρηση αξιολογεί το σχήμα στο μέσο του σώματος.',
    hr:
      'WHR se općenito koristi za procjenu visokog rizika od pretilosti, dijabetesa, koronarne bolesti i/ili visokog tlaka. Mjerenje ocjenjuje oblik sredine tijela.',
  },
}

export default expandKeyedTranslations(glossaryPhrases)
